import { g as Un } from "./main-UMBqf2Ea.js";
function Vn(le, we) {
  for (var M = 0; M < we.length; M++) {
    const T = we[M];
    if (typeof T != "string" && !Array.isArray(T)) {
      for (const p in T)
        if (p !== "default" && !(p in le)) {
          const v = Object.getOwnPropertyDescriptor(T, p);
          v && Object.defineProperty(le, p, v.get ? v : {
            enumerable: !0,
            get: () => T[p]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(le, Symbol.toStringTag, { value: "Module" }));
}
var ot = { exports: {} };
(function(le, we) {
  (function(T, p) {
    le.exports = p();
  })(window, function() {
    return (
      /******/
      function(M) {
        var T = {};
        function p(v) {
          if (T[v])
            return T[v].exports;
          var b = T[v] = {
            /******/
            i: v,
            /******/
            l: !1,
            /******/
            exports: {}
            /******/
          };
          return M[v].call(b.exports, b, b.exports, p), b.l = !0, b.exports;
        }
        return p.m = M, p.c = T, p.d = function(v, b, m) {
          p.o(v, b) || Object.defineProperty(v, b, { enumerable: !0, get: m });
        }, p.r = function(v) {
          typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(v, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(v, "__esModule", { value: !0 });
        }, p.t = function(v, b) {
          if (b & 1 && (v = p(v)), b & 8 || b & 4 && typeof v == "object" && v && v.__esModule) return v;
          var m = /* @__PURE__ */ Object.create(null);
          if (p.r(m), Object.defineProperty(m, "default", { enumerable: !0, value: v }), b & 2 && typeof v != "string") for (var I in v) p.d(m, I, (function(d) {
            return v[d];
          }).bind(null, I));
          return m;
        }, p.n = function(v) {
          var b = v && v.__esModule ? (
            /******/
            function() {
              return v.default;
            }
          ) : (
            /******/
            function() {
              return v;
            }
          );
          return p.d(b, "a", b), b;
        }, p.o = function(v, b) {
          return Object.prototype.hasOwnProperty.call(v, b);
        }, p.p = "", p(p.s = 6);
      }([
        /* 0 */
        /***/
        function(M, T) {
          var p;
          p = /* @__PURE__ */ function() {
            return this;
          }();
          try {
            p = p || Function("return this")() || (0, eval)("this");
          } catch {
            typeof window == "object" && (p = window);
          }
          M.exports = p;
        },
        /* 1 */
        /***/
        function(M, T, p) {
          function v() {
            return v = Object.assign || function(u) {
              for (var C = 1; C < arguments.length; C++) {
                var B = arguments[C];
                for (var W in B)
                  Object.prototype.hasOwnProperty.call(B, W) && (u[W] = B[W]);
              }
              return u;
            }, v.apply(this, arguments);
          }
          var b = p(14), m = p(13), I, d, h, k = function(C) {
            return C.tagName.toLowerCase() !== "svg";
          };
          function L(u, C) {
            var B;
            return C === !1 ? B = x(u, "aria-hidden", "false") : B = x(u, "hidden", !1), B;
          }
          function _(u, C) {
            var B;
            return C === !1 ? B = x(u, "aria-hidden", "true") : B = x(u, "hidden", !0), B;
          }
          function x(u, C, B) {
            var W = typeof B == "boolean";
            return {
              el: u,
              attributeName: C,
              cleanValue: W ? u[C] : u.getAttribute(C),
              dirtyValue: B,
              isProperty: W
            };
          }
          function A(u) {
            u.isProperty === !0 ? u.el[u.attributeName] = u.dirtyValue : u.el.setAttribute(u.attributeName, u.dirtyValue);
          }
          function y(u) {
            u.cleanValue ? u.isProperty === !0 ? u.el[u.attributeName] = u.cleanValue : u.el.setAttribute(u.attributeName, u.cleanValue) : u.el.removeAttribute(u.attributeName);
          }
          function s() {
            d && (h.forEach(function(u) {
              return y(u);
            }), h = [], I && I.setAttribute("role", "main"), d.dispatchEvent(new b("screenreaderUntrap", {
              bubbles: !0
            })), d = null);
          }
          var c = {
            useHiddenProperty: !1
          };
          function w(u, C) {
            s();
            var B = v({}, c, C);
            d = u, I = document.querySelector('main, [role="main"]'), I && I.setAttribute("role", "presentation");
            var W = m.getAncestors(d), $ = m.getSiblings(d), F = m.getSiblingsOfAncestors(d);
            B.useHiddenProperty === !0 && ($ = $.filter(k), F = F.filter(k)), h = [L(d, B.useHiddenProperty)].concat(W.map(function(l) {
              return L(l, B.useHiddenProperty);
            })).concat($.map(function(l) {
              return _(l, B.useHiddenProperty);
            })).concat(F.map(function(l) {
              return _(l, B.useHiddenProperty);
            })), h.forEach(function(l) {
              return A(l);
            }), d.dispatchEvent(new b("screenreaderTrap", {
              bubbles: !0
            }));
          }
          M.exports = {
            trap: w,
            untrap: s
          };
        },
        /* 2 */
        /***/
        function(M, T, p) {
          var v, b, m;
          (function(I, d) {
            b = [p(7)], v = d, m = typeof v == "function" ? v.apply(T, b) : v, m !== void 0 && (M.exports = m);
          })(this, function(d) {
            var h = /(^|@)\S+\:\d+/, k = /^\s*at .*(\S+\:\d+|\(native\))/m, L = /^(eval@)?(\[native code\])?$/;
            return {
              /**
               * Given an Error object, extract the most information from it.
               *
               * @param {Error} error object
               * @return {Array} of StackFrames
               */
              parse: function(x) {
                if (typeof x.stacktrace < "u" || typeof x["opera#sourceloc"] < "u")
                  return this.parseOpera(x);
                if (x.stack && x.stack.match(k))
                  return this.parseV8OrIE(x);
                if (x.stack)
                  return this.parseFFOrSafari(x);
                throw new Error("Cannot parse given Error object");
              },
              // Separate line and column numbers from a string of the form: (URI:Line:Column)
              extractLocation: function(x) {
                if (x.indexOf(":") === -1)
                  return [x];
                var A = /(.+?)(?:\:(\d+))?(?:\:(\d+))?$/, y = A.exec(x.replace(/[\(\)]/g, ""));
                return [y[1], y[2] || void 0, y[3] || void 0];
              },
              parseV8OrIE: function(x) {
                var A = x.stack.split(`
`).filter(function(y) {
                  return !!y.match(k);
                }, this);
                return A.map(function(y) {
                  y.indexOf("(eval ") > -1 && (y = y.replace(/eval code/g, "eval").replace(/(\(eval at [^\()]*)|(\)\,.*$)/g, ""));
                  var s = y.replace(/^\s+/, "").replace(/\(eval code/g, "(").split(/\s+/).slice(1), c = this.extractLocation(s.pop()), w = s.join(" ") || void 0, u = ["eval", "<anonymous>"].indexOf(c[0]) > -1 ? void 0 : c[0];
                  return new d({
                    functionName: w,
                    fileName: u,
                    lineNumber: c[1],
                    columnNumber: c[2],
                    source: y
                  });
                }, this);
              },
              parseFFOrSafari: function(x) {
                var A = x.stack.split(`
`).filter(function(y) {
                  return !y.match(L);
                }, this);
                return A.map(function(y) {
                  if (y.indexOf(" > eval") > -1 && (y = y.replace(/ line (\d+)(?: > eval line \d+)* > eval\:\d+\:\d+/g, ":$1")), y.indexOf("@") === -1 && y.indexOf(":") === -1)
                    return new d({
                      functionName: y
                    });
                  var s = /((.*".+"[^@]*)?[^@]*)(?:@)/, c = y.match(s), w = c && c[1] ? c[1] : void 0, u = this.extractLocation(y.replace(s, ""));
                  return new d({
                    functionName: w,
                    fileName: u[0],
                    lineNumber: u[1],
                    columnNumber: u[2],
                    source: y
                  });
                }, this);
              },
              parseOpera: function(x) {
                return !x.stacktrace || x.message.indexOf(`
`) > -1 && x.message.split(`
`).length > x.stacktrace.split(`
`).length ? this.parseOpera9(x) : x.stack ? this.parseOpera11(x) : this.parseOpera10(x);
              },
              parseOpera9: function(x) {
                for (var A = /Line (\d+).*script (?:in )?(\S+)/i, y = x.message.split(`
`), s = [], c = 2, w = y.length; c < w; c += 2) {
                  var u = A.exec(y[c]);
                  u && s.push(new d({
                    fileName: u[2],
                    lineNumber: u[1],
                    source: y[c]
                  }));
                }
                return s;
              },
              parseOpera10: function(x) {
                for (var A = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, y = x.stacktrace.split(`
`), s = [], c = 0, w = y.length; c < w; c += 2) {
                  var u = A.exec(y[c]);
                  u && s.push(
                    new d({
                      functionName: u[3] || void 0,
                      fileName: u[2],
                      lineNumber: u[1],
                      source: y[c]
                    })
                  );
                }
                return s;
              },
              // Opera 10.65+ Error.stack very similar to FF/Safari
              parseOpera11: function(x) {
                var A = x.stack.split(`
`).filter(function(y) {
                  return !!y.match(h) && !y.match(/^Error created at/);
                }, this);
                return A.map(function(y) {
                  var s = y.split("@"), c = this.extractLocation(s.pop()), w = s.shift() || "", u = w.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^\)]*\)/g, "") || void 0, C;
                  w.match(/\(([^\)]*)\)/) && (C = w.replace(/^[^\(]+\(([^\)]*)\)$/, "$1"));
                  var B = C === void 0 || C === "[arguments not available]" ? void 0 : C.split(",");
                  return new d({
                    functionName: u,
                    args: B,
                    fileName: c[0],
                    lineNumber: c[1],
                    columnNumber: c[2],
                    source: y
                  });
                }, this);
              }
            };
          });
        },
        /* 3 */
        /***/
        function(M, T, p) {
          Object.defineProperty(T, "__esModule", { value: !0 });
          var v = function() {
            function b(m) {
              var I = m === void 0 ? { emit: !1, logger: console.log } : m, d = I.emit, h = I.logger;
              this.emit = d, this.externalLogger = h, this.buffer = [], this.customLevel = {}, this.error = this.setLevel(1), this.warn = this.setLevel(2), this.info = this.setLevel(3), this.log = this.setLevel(4);
            }
            return b.prototype.getLogs = function(m) {
              return typeof m == "function" ? this.buffer.filter(function(I) {
                return I.level === m.level;
              }) : m ? this.buffer.filter(function(I) {
                return I.level === m;
              }) : this.buffer;
            }, b.prototype.setLevel = function(m) {
              var I = this, d = function() {
                for (var h = [], k = 0; k < arguments.length; k++)
                  h[k] = arguments[k];
                var L = { level: m, time: Date.now(), msg: h.join(" ") };
                I.buffer.push(L), I.emit && I.externalLogger(L);
              };
              return d.level = m, this.customLevel[m] = d, d;
            }, b;
          }();
          T.default = v;
        },
        /* 4 */
        /***/
        function(M, T, p) {
          T.a = function(v) {
            var b = this.constructor;
            return this.then(
              function(m) {
                return b.resolve(v()).then(function() {
                  return m;
                });
              },
              function(m) {
                return b.resolve(v()).then(function() {
                  return b.reject(m);
                });
              }
            );
          };
        },
        /* 5 */
        /***/
        function(M, T, p) {
          (function(v) {
            var b = p(4), m = setTimeout;
            function I() {
            }
            function d(s, c) {
              return function() {
                s.apply(c, arguments);
              };
            }
            function h(s) {
              if (!(this instanceof h))
                throw new TypeError("Promises must be constructed via new");
              if (typeof s != "function") throw new TypeError("not a function");
              this._state = 0, this._handled = !1, this._value = void 0, this._deferreds = [], y(s, this);
            }
            function k(s, c) {
              for (; s._state === 3; )
                s = s._value;
              if (s._state === 0) {
                s._deferreds.push(c);
                return;
              }
              s._handled = !0, h._immediateFn(function() {
                var w = s._state === 1 ? c.onFulfilled : c.onRejected;
                if (w === null) {
                  (s._state === 1 ? L : _)(c.promise, s._value);
                  return;
                }
                var u;
                try {
                  u = w(s._value);
                } catch (C) {
                  _(c.promise, C);
                  return;
                }
                L(c.promise, u);
              });
            }
            function L(s, c) {
              try {
                if (c === s)
                  throw new TypeError("A promise cannot be resolved with itself.");
                if (c && (typeof c == "object" || typeof c == "function")) {
                  var w = c.then;
                  if (c instanceof h) {
                    s._state = 3, s._value = c, x(s);
                    return;
                  } else if (typeof w == "function") {
                    y(d(w, c), s);
                    return;
                  }
                }
                s._state = 1, s._value = c, x(s);
              } catch (u) {
                _(s, u);
              }
            }
            function _(s, c) {
              s._state = 2, s._value = c, x(s);
            }
            function x(s) {
              s._state === 2 && s._deferreds.length === 0 && h._immediateFn(function() {
                s._handled || h._unhandledRejectionFn(s._value);
              });
              for (var c = 0, w = s._deferreds.length; c < w; c++)
                k(s, s._deferreds[c]);
              s._deferreds = null;
            }
            function A(s, c, w) {
              this.onFulfilled = typeof s == "function" ? s : null, this.onRejected = typeof c == "function" ? c : null, this.promise = w;
            }
            function y(s, c) {
              var w = !1;
              try {
                s(
                  function(u) {
                    w || (w = !0, L(c, u));
                  },
                  function(u) {
                    w || (w = !0, _(c, u));
                  }
                );
              } catch (u) {
                if (w) return;
                w = !0, _(c, u);
              }
            }
            h.prototype.catch = function(s) {
              return this.then(null, s);
            }, h.prototype.then = function(s, c) {
              var w = new this.constructor(I);
              return k(this, new A(s, c, w)), w;
            }, h.prototype.finally = b.a, h.all = function(s) {
              return new h(function(c, w) {
                if (!s || typeof s.length > "u")
                  throw new TypeError("Promise.all accepts an array");
                var u = Array.prototype.slice.call(s);
                if (u.length === 0) return c([]);
                var C = u.length;
                function B($, F) {
                  try {
                    if (F && (typeof F == "object" || typeof F == "function")) {
                      var l = F.then;
                      if (typeof l == "function") {
                        l.call(
                          F,
                          function(f) {
                            B($, f);
                          },
                          w
                        );
                        return;
                      }
                    }
                    u[$] = F, --C === 0 && c(u);
                  } catch (f) {
                    w(f);
                  }
                }
                for (var W = 0; W < u.length; W++)
                  B(W, u[W]);
              });
            }, h.resolve = function(s) {
              return s && typeof s == "object" && s.constructor === h ? s : new h(function(c) {
                c(s);
              });
            }, h.reject = function(s) {
              return new h(function(c, w) {
                w(s);
              });
            }, h.race = function(s) {
              return new h(function(c, w) {
                for (var u = 0, C = s.length; u < C; u++)
                  s[u].then(c, w);
              });
            }, h._immediateFn = typeof v == "function" && function(s) {
              v(s);
            } || function(s) {
              m(s, 0);
            }, h._unhandledRejectionFn = function(c) {
              typeof console < "u" && console && console.warn("Possible Unhandled Promise Rejection:", c);
            }, T.a = h;
          }).call(this, p(18).setImmediate);
        },
        /* 6 */
        /***/
        function(M, T, p) {
          p.r(T);
          var v = p(5), b = function(t) {
            return typeof t == "function";
          }, m = function(t) {
            var e = window.Promise;
            return e && e.all && e.race && e.resolve && e.reject && b(e) && b(e.all) && b(e.race) && b(e.resolve) && b(e.reject);
          }, I = m() ? window.Promise : v.a, d = I, h = function(t, e, r, n) {
            return n === void 0 && (n = window), window.addEventListener ? n.addEventListener(t, r, !1) : window.attachEvent && n.attachEvent(e, r), { eventName: t, handler: r, element: n };
          }, k = function(t, e, r) {
            r === void 0 && (r = window), r.removeEventListener ? r.removeEventListener(t, e, !1) : r.detachEvent ? r.detachEvent("on" + t, e) : r["on" + t] = null;
          }, L = function(t, e) {
            if (typeof window.CustomEvent == "function")
              return new window.CustomEvent(t, { detail: e });
            if (typeof document.createEvent == "function") {
              var r = document.createEvent("CustomEvent");
              return r.initCustomEvent(t, !1, !1, e), r;
            }
          }, _ = function(t) {
            for (var e in t)
              if (t.hasOwnProperty(e))
                return !1;
            return JSON.stringify(t) === JSON.stringify({});
          }, x = function(t, e) {
            if (e.indexOf)
              return e.indexOf(t);
            for (var r = 0; r < e.length; r++)
              if (e[r] === t)
                return r;
            return -1;
          }, A = function(t, e) {
            for (var r in e)
              e.hasOwnProperty(r) && (t[r] = e[r]);
            return t;
          }, y = function(t, e, r) {
            if (e === void 0 && (e = "*"), r === void 0 && (r = document), typeof document.getElementsByClassName == "function")
              return r.getElementsByClassName(t);
            for (var n = [], a = new RegExp("(^| )" + t + "( |$)"), i = l(r.getElementsByTagName(e)), o = 0, g = i; o < g.length; o++) {
              var S = g[o];
              a.test(S.className) && n.push(S);
            }
            return n;
          }, s = function(t, e) {
            e === void 0 && (e = 0);
            var r = F(t);
            return r.height !== 0 || r.width !== 0 ? (r.height / (r.width + e) * 100).toFixed(2) : (9 / 16 * 100).toFixed(2);
          }, c = function(t, e) {
            e === void 0 && (e = "log"), window.console && typeof window.console[e] == "function" && console[e](t);
          }, w = function(t, e) {
            for (var r = 0, n = t; r < n.length; r++) {
              var a = n[r], i = e(a);
              if (i === !0)
                return a;
            }
          }, u = function(t, e) {
            return w(t, function(r) {
              return r === e;
            });
          }, C = function(t) {
            var e = !1;
            return function() {
              for (var r = [], n = 0; n < arguments.length; n++)
                r[n] = arguments[n];
              e || (t && t.apply(void 0, r), e = !0);
            };
          }, B = function(t) {
            return function(e) {
              (e.keyCode === 32 || e.keyCode === 13) && t(e);
            };
          }, W = function(t) {
            return function(e) {
              e.keyCode === 27 && t(e);
            };
          }, $ = function() {
            return document.currentScript ? document.currentScript : w(l(document.getElementsByTagName("script")), function(t) {
              return t.src && (t.src.match("vidyard-embed-code.js") !== null || t.src.match(/v4(\.umd)?\.js/) !== null);
            });
          }, F = function(t) {
            if (t.naturalWidth)
              return { width: t.naturalWidth, height: t.naturalHeight };
            var e = new Image();
            return e.src = t.src, { width: e.width, height: e.height };
          }, l = function(t) {
            return Array.prototype.slice.call(t);
          }, f = function(t) {
            return new d(function(e, r) {
              try {
                e(JSON.parse(t));
              } catch (n) {
                r(n);
              }
            });
          }, O = function(t) {
            var e = t.endpoint, r = t.payload, n = r === void 0 ? {} : r, a = t.method, i = a === void 0 ? "GET" : a;
            return new d(function(o, g) {
              var S = new XMLHttpRequest().withCredentials === void 0 && XDomainRequest, N = S ? new XDomainRequest() : new XMLHttpRequest();
              N.open(i, e), N instanceof XMLHttpRequest && N.setRequestHeader("Content-Type", "text/plain"), N.onerror = function(R) {
                return g(R);
              }, N.onload = function() {
                N instanceof XMLHttpRequest ? Math.floor(N.status / 100) === 2 ? o(N.responseText) : g() : o(N.responseText);
              }, N.send(JSON.stringify(n));
            });
          }, V = function() {
            for (var t = [
              // Spec: https://dvcs.w3.org/hg/fullscreen/raw-file/tip/Overview.html
              ["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenchange"],
              // WebKit
              [
                "webkitRequestFullscreen",
                "webkitExitFullscreen",
                "webkitFullscreenElement",
                "webkitfullscreenchange"
              ],
              // Mozilla
              ["mozRequestFullScreen", "mozCancelFullScreen", "mozFullScreenElement", "mozfullscreenchange"],
              // Microsoft
              ["msRequestFullscreen", "msExitFullscreen", "msFullscreenElement", "MSFullscreenChange"]
            ], e = [], r = {}, n = 0, a = t; n < a.length; n++) {
              var i = a[n];
              if (i[1] in document) {
                e = i;
                break;
              }
            }
            if (e && e.length) {
              for (var o = 0; o < e.length; o++)
                r[t[0][o]] = e[o];
              return r;
            } else
              return null;
          }, j = function(t) {
            for (var e = {}, r = function(i) {
              return i.name.replace("data-", "");
            }, n = 0; n < t.attributes.length; n += 1) {
              var a = t.attributes[n];
              a.name.indexOf("data-") < 0 || (e[r(a)] = a.value);
            }
            return e;
          }, D = function(t) {
            t = t.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
            var e = "[\\?&]" + t + "=([^&#]*)", r = new RegExp(e), n = r.exec(window.location.search);
            if (n !== null)
              return n[1];
          }, H = function(t, e) {
            try {
              var r = JSON.parse(decodeURIComponent(t));
              return Object.keys(r).reduce(function(n, a) {
                return n[e + "[" + a + "]"] = r[a], n;
              }, {});
            } catch {
              return c("Invalid " + e + " payload", "warn"), {};
            }
          }, ee = function(t) {
            return Object.keys(t).reduce(function(e, r) {
              if (r === "vydata") {
                var n = H(t[r], "vydata");
                Object.keys(n).forEach(function(a) {
                  e[a] = n[a];
                });
              } else
                e[r] = t[r];
              return e;
            }, {});
          }, K = function(t, e, r) {
            var n = function(o, g) {
              return o.className.indexOf(g) !== -1;
            }, a = function(o, g) {
              n(o, g) || (o.className = o.className.trim() + " " + g);
            }, i = function(o, g) {
              n(o, g) && (o.className = o.className.replace(g, " ").trim());
            };
            r === !0 ? a(t, e) : r === !1 || n(t, e) ? i(t, e) : a(t, e);
          }, re = "4.3.15", ne = /vidyard\.com\/embed\/v4/, st = "/integrations.js", ct = 0.5, lt = 319, dt = "/details.js", ft = "/style.js", Ne = /* @__PURE__ */ function() {
            var e;
            return {
              setPlaybackURL: function(r) {
                return e = r, e;
              },
              getPlaybackURL: function() {
                var r = $(), n = r ? r.getAttribute("data-playbackurl") : null;
                return e || window.VIDYARD_PLAYBACK_URL || n || "play.vidyard.com";
              }
            };
          }(), vt = Ne.setPlaybackURL, J = Ne.getPlaybackURL, he = function() {
            return "https://" + J() + "/v4/";
          }, pt = function() {
            return "https://" + J() + "/v4/error";
          }, de = function(t, e, r) {
            if (!(!e || !r))
              if (window.postMessage && r.contentWindow)
                r.contentWindow.postMessage(JSON.stringify(t), e);
              else {
                if (t.event !== "associateVisitor")
                  return;
                var n = t.event + "," + t.data.type + "," + t.data.value + "|", a = r.src;
                a.indexOf("#") === -1 && (a += "#"), a += n, r.src = a;
              }
          }, Re = function(t) {
            return function(e) {
              var r = ht(e);
              r && t(r);
            };
          };
          function ht(t) {
            if (!(typeof t.data != "string" || t.data === ""))
              try {
                var e = JSON.parse(t.data), r = y("vidyard-iframe-" + e.uuid, "iframe")[0], n = r ? r.contentWindow : null, a = n === t.source, i = typeof e.event == "string";
                return !a || !i ? void 0 : e;
              } catch {
                c("Invalid postMessage received", "warn");
                return;
              }
          }
          var mt = [
            "pardot",
            "hubspotutk",
            "_mkto_trk",
            "vy_dreamforce",
            "eloqua"
          ], Fe = [
            "pardot",
            "hubspot",
            "marketo",
            "dreamforce",
            "eloqua"
          ];
          function yt() {
            var t = this, e = !1, r = {};
            this.updatePlayer = function(E) {
              if (!(!E._tmpOrg || !E.iframe)) {
                var P = E._tmpOrg.orgId;
                r[P] || (r[P] = {
                  foundIntegrations: {},
                  id: P,
                  // All integrations supported by this organization
                  integrations: E._tmpOrg,
                  // Store of cookie data found keyed by integration name
                  // Each integration has an externalIdentifier set with the tracking cookie/uuid if found
                  // as well as an object with which players have been sent the associateVisitor event
                  // e.g. {integration: {externalIdentifier: 'cookie_value', sentPlayers: ['player1.uuid']}}
                  // In DOM players associated with this organization
                  players: []
                }), E.org = r[P];
                for (var U = 0, q = r[P].players; U < q.length; U++) {
                  var G = q[U];
                  if (G.iframe === E.iframe)
                    return;
                }
                r[P].players.push(E);
                var Q = E.org.integrations, oe = Q.eloqua, pe = Q.eloquaFirstPartyDomain;
                oe && (E.status !== null && E.status.consent ? ce(oe, pe) : E.on("status", function Le() {
                  E.status.consent && (ce(oe, pe), E.off("status", Le));
                })), z();
              }
            }, this.safelyCommunicateIntegration = function(E, P, U) {
              E.org !== void 0 && U !== void 0 && U !== null && !n(E, P) && g(E, P, U) && (E.org = i(E.org, P, E.uuid));
            }, this.addKnownVisitor = function(E, P, U) {
              if (U)
                for (var q = 0, G = U.players; q < G.length; q++) {
                  var Q = G[q];
                  R(Q, E, P);
                }
            }, this.getCookie = function(E, P) {
              var U = document.cookie.split(";");
              if (E === "eloqua" && typeof window.GetElqCustomerGUID == "function")
                return window.GetElqCustomerGUID();
              for (var q = X(mt[Fe.indexOf(E)], P), G = 0, Q = U; G < Q.length; G++) {
                var oe = Q[G], pe = oe.indexOf("="), Le = oe.substr(0, pe).replace(/^\s+|\s+$/g, ""), Fn = oe.substr(pe + 1);
                if (Le === q)
                  return decodeURIComponent(Fn);
              }
            };
            var n = function(E, P) {
              return E.org && E.org.foundIntegrations && E.org.foundIntegrations[P] && E.org.foundIntegrations[P].sentPlayers && x(E.uuid, E.org.foundIntegrations[P].sentPlayers) !== -1;
            }, a = function(E, P) {
              return E.foundIntegrations[P] || (E.foundIntegrations[P] = {
                externalIdentifier: null,
                sentPlayers: []
              }), E;
            }, i = function(E, P, U) {
              return E = a(E, P), E.foundIntegrations[P].sentPlayers.push(U), E;
            }, o = function(E, P, U) {
              return E = a(E, P), E.foundIntegrations[P].externalIdentifier = U, E;
            }, g = function(E, P, U) {
              if (!E.ready())
                return !1;
              var q = {
                data: { type: P, value: U },
                event: "associateVisitor",
                uuid: E.uuid
              };
              return c("IntegrationsWatcher.communicateIntegration " + q, "debug"), de(q, "https://" + J(), E.iframe), !0;
            }, S = function(E, P, U) {
              if (!(E === void 0 || U === void 0 || U === null))
                for (var q = 0, G = E; q < G.length; q++) {
                  var Q = G[q];
                  t.safelyCommunicateIntegration(Q, P, U);
                }
            }, N = function(E, P, U) {
              var q = {
                data: { type: P, value: U },
                event: "identifyVisitor",
                uuid: E.uuid
              };
              de(q, "https://" + J(), E.iframe);
            }, R = function(E, P, U) {
              E.ready() ? N(E, P, U) : E.on("ready", function() {
                N(E, P, U);
              });
            }, z = function() {
              for (var E = 0, P = Fe; E < P.length; E++) {
                var U = P[E];
                for (var q in r)
                  if (r.hasOwnProperty(q)) {
                    var G = r[q];
                    if (!G.integrations[U])
                      continue;
                    var Q = t.getCookie(U, G);
                    if (!Q || (Q = Z(U, Q, G), !Q))
                      continue;
                    G = o(G, U, Q), S(G.players, U, Q);
                  }
              }
            }, X = function(E, P) {
              return E === "pardot" && P && P.integrations.pardot ? "visitor_id" + P.integrations.pardot : E;
            }, Z = function(E, P, U) {
              if (E === "marketo") {
                if (!U.integrations.marketo || P.toLowerCase().indexOf(U.integrations.marketo.toLowerCase()) === -1)
                  return null;
                P = encodeURIComponent(P);
              }
              return P;
            }, ce = function(E, P) {
              if (!e) {
                e = !0;
                var U = function() {
                  if (!document.getElementById("vidyard-eloqua-include")) {
                    window._elqQ = window._elqQ || [], window._elqQ.push(["elqSetSiteId", E]), P && window._elqQ.push(["elqUseFirstPartyCookie", P]), window._elqQ.push(["elqTrackPageView"]), window._elqQ.push(["elqGetCustomerGUID"]);
                    var q = document.createElement("script");
                    q.id = "vidyard-eloqua-include", q.type = "text/javascript", q.async = !0, q.src = "https://img.en25.com/i/elqCfg.min.js";
                    var G = document.getElementsByTagName("script")[0];
                    G.parentNode.insertBefore(q, G);
                  }
                };
                document.readyState === "complete" ? U() : h("DOMContentLoaded", "onload", U);
              }
            };
            setInterval(function() {
              z();
            }, 1e3);
          }
          var gt = function() {
            window.onVidyardAPI && typeof window.onVidyardAPI == "function" && window.onVidyardAPI(window.VidyardV4);
          }, bt = function() {
            document.dispatchEvent(L("onVidyardAPI", window.VidyardV4));
          }, wt = C(function() {
            gt(), bt();
          }), Ue = wt, xt = p(3), Et = /* @__PURE__ */ p.n(xt), Y = new Et.a({
            emit: !!window.location.search.match("vydebug=1"),
            logger: function(t) {
              return c(t, "info");
            }
          }), xe = $();
          xe && (Y.info("vidyardEmbed V" + re + " loaded from " + xe.src), Y.info("data-playbackurl=" + xe.getAttribute("data-playbackurl"))), Y.info("userAgent " + window.navigator.userAgent), Y.info("cookies " + navigator.cookieEnabled), window.performance && window.performance.timing && window.performance.timing.navigationStart && Y.info("Script load time " + (Date.now() - window.performance.timing.navigationStart));
          var kt = { logger: Y, getPlaybackURL: J, setPlaybackURL: vt, version: re }, It = kt;
          function St(t, e) {
            var r = window.VidyardV4.playerReadyListeners;
            r[e] = r[e] || [], r[e].push(t);
            for (var n = 0, a = window.VidyardV4.players; n < a.length; n++) {
              var i = a[n];
              e !== void 0 && i.uuid !== e || i.on("ready", t);
            }
          }
          function Ct(t) {
            var e = window.VidyardV4.playerReadyListeners, r = t.uuid, n = Y.setLevel(t.uuid);
            e[r] = e[r] || [];
            var a = e[r].concat(e[void 0]);
            Object.keys(a).forEach(function(i) {
              var o = a[i];
              t.on("ready", o), n("attaching ready callbacks");
            });
          }
          var At = function() {
            var t = [
              "autoplay",
              "fullscreen",
              "picture-in-picture",
              "camera",
              "microphone",
              "display-capture",
              "clipboard-write"
            ];
            return t.join("; ");
          }, Ve = function(t, e) {
            var r = function(n) {
              return t.type === "inline" ? '<div class="vidyard-inner-container-' + t.uuid + '" style="position: absolute;height: 100%; width: 100%; ' + (e.maxWidth ? "max-width: " + e.maxWidth + "px; " : "") + (e.maxHeight ? "max-height: " + e.maxHeight + "px; " : "") + '"> ' + n + "</div> " : n;
            };
            return '<div class="vidyard-div-' + t.uuid + '" role="region" aria-label="Vidyard media player" style="position: absolute; padding-bottom: ' + e.ratio + '%; height: 0; overflow: hidden; max-width: 100%; ">' + r('<iframe allow="' + At() + '"allowfullscreen allowtransparency="true" referrerpolicy="no-referrer-when-downgrade" class="vidyard-iframe-' + t.uuid + '" frameborder=0 height="100%" width="100%" scrolling=no src="https://' + J() + "/" + t.uuid + t.toQueryString() + '" title="Vidyard video player" style="opacity: 0; background-color: transparent; position: absolute; top: 0; left: 0;"></iframe>') + "</div>";
          }, Ot = function(t) {
            var e = document.createElement("script");
            return e.type = "application/ld+json", e.text = JSON.stringify(t), e;
          }, Me = function(t) {
            return new d(function(e, r) {
              return ye({
                error: r,
                success: e,
                url: "" + he() + t + ft,
                uuid: "style_" + t
              });
            });
          }, _t = function(t) {
            return new d(function(e, r) {
              return ye({
                error: r,
                success: e,
                url: "" + he() + t + st,
                uuid: "integrations_" + t
              });
            });
          }, Pt = function(t) {
            return new d(function(e, r) {
              return ye({
                error: r,
                success: e,
                url: "" + he() + t + dt,
                uuid: "details_" + t
              });
            });
          }, Tt = function(t, e) {
            return new d(function(r, n) {
              var a = encodeURIComponent(e), i = "" + he() + t + "/contact/" + a + "/marketoContact.js";
              ye({
                error: n,
                success: r,
                url: i,
                uuid: "marketoContact_" + t
              });
            });
          }, Lt = function(t) {
            var e = t.error, r = t.url, n = t.requestUuid, a = document.createElement("script");
            return a.type = "application/javascript", a.onerror = e, a.src = r + "?callback=window.VidyardV4.jsonp." + n + ".done", a.setAttribute("data-playbackurl", J()), document.body.appendChild(a), a;
          }, me = {}, ye = function(t) {
            var e = t.url, r = t.uuid, n = t.success, a = t.error, i = r.replace(/-/g, ""), o = Lt({ error: a, url: e, requestUuid: i }), g = C(function(S) {
              n(S), o.parentNode.removeChild(o);
            });
            me[i] = me[i] || [], me[i].push(g), window.VidyardV4.jsonp[i] = {
              done: function(S) {
                me[i].forEach(function(N) {
                  return N(S);
                });
              }
            };
          }, ge = {
            errors: {
              placeholder: "Cannot render the player, check the placeholder Image"
            }
          }, Nt = function(t, e) {
            var r = {};
            for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
            if (t != null && typeof Object.getOwnPropertySymbols == "function")
              for (var a = 0, n = Object.getOwnPropertySymbols(t); a < n.length; a++) e.indexOf(n[a]) < 0 && (r[n[a]] = t[n[a]]);
            return r;
          }, De = function(t) {
            if (!t)
              return d.reject(new Error(ge.errors.placeholder));
            var e = F(t), r = e.width, n = e.height, a = t.getAttribute("data-uuid");
            return t.src === "" || !a ? d.reject(new Error(ge.errors.placeholder)) : t.complete && (r === 0 || n === 0) ? d.reject(new Error(ge.errors.placeholder)) : t.complete ? d.resolve(t) : new d(function(i, o) {
              t.onload = function() {
                return i(t);
              }, t.onerror = function() {
                return o(t);
              };
            });
          }, Rt = function(t) {
            t === void 0 && (t = {});
            var e = t.uuid, r = t.container, n = t.type, a = n === void 0 ? "inline" : n;
            t.aspect;
            var i = Nt(t, ["uuid", "container", "type", "aspect"]);
            if (!(!e || !r)) {
              Y.setLevel("placeholder")("creating placeholder image");
              var o = document.createElement("img"), g = i.width ? i.width + "px" : "100%", S = i.height ? i.height + "px" : "100%", N = `
    display: block;
    margin: 0 auto;
    max-height: ` + S + `;
    max-width: ` + g + `;
    opacity: 0;
  `;
              return o.src = "https://" + J() + "/" + e + ".jpg", o.className = "vidyard-player-embed", o.setAttribute("style", N), o.setAttribute("data-uuid", e), o.setAttribute("data-type", a), Object.keys(i).forEach(function(R) {
                return o.setAttribute("data-" + R, i[R]);
              }), r.appendChild(o);
            }
          }, Ft = function(t) {
            var e = document.createElement("img");
            return e.setAttribute("data-uuid", t), e.src = "//" + J() + "/" + t + ".jpg", De(e);
          }, Ut = function(t) {
            var e = t.dataParams, r = t.player, n = Y.setLevel(e.uuid);
            n("injecting inline embed");
            var a = function() {
              return r.placeholder.src !== "//" + J() + "/" + r.uuid + ".jpg" ? Ft(r.uuid).then(s).catch(function() {
                return !1;
              }) : d.resolve(!1);
            }, i = {
              maxHeight: e.height ? parseInt(e.height, 10).toString() : null,
              maxWidth: e.width ? parseInt(e.width, 10).toString() : null,
              ratio: s(r.placeholder)
            };
            r.container.innerHTML = Ve(e, i);
            var o = r.container.getElementsByTagName("iframe")[0];
            r.iframe = o;
            var g = new d(function(R) {
              h("load", "onload", R, o);
            }), S = new d(function(R) {
              r.on("ready", R);
            });
            r.on("sidePlaylistOpen", function() {
              N();
            }), d.race([g, S]).then(function() {
              n("player or iFrame is ready"), a().then(function(z) {
                z && (o.parentElement.parentElement.style.paddingBottom = z + "%");
              });
              var R = r.container.getElementsByClassName("vidyard-inner-container-" + r.uuid)[0];
              r.placeholder.parentElement.removeChild(r.placeholder), K(r.placeholder, "inserted", !0), R.appendChild(r.placeholder), o.parentElement.parentElement.style.position = "relative", o.style.opacity = "1";
            }), g.then(function() {
              r.placeholder.style.display = "none", o.parentElement.parentElement.style.backgroundColor = "transparent";
            }), r.on("metadata", function R(z) {
              var X = z[0];
              o.title = X.name, r.off("metadata", R);
            });
            function N() {
              var R = r.container.clientWidth >= lt * 2;
              K(r.container, "playlist-open", R);
            }
            n("getStyle sent"), Me(r.uuid).then(
              // pl is the "playlist always open" setting from the Dashboard.
              function(R) {
                n("getStyle received: " + JSON.stringify(R));
                var z = R.pl === 1 && e.playlist_always_open !== "0" || e.playlist_always_open === "1";
                z ? (r.iframe.parentElement.setAttribute("data-pl", "true"), h("resize", "onresize", N), N()) : r.iframe.parentElement.setAttribute("data-pl", "false");
              }
            ).catch(function(R) {
              n("getStyle failed, likely a network error");
            });
          }, Vt = Ut, Mt = function(t) {
            t === void 0 && (t = document.body);
            for (var e = 0, r = Array.from(t.children); e < r.length; e++) {
              var n = r[e];
              n.hasAttribute("aria-hidden") && n.setAttribute("data-vy-keep-hidden", n.getAttribute("aria-hidden")), n.setAttribute("aria-hidden", "true");
            }
          }, Dt = function(t) {
            t === void 0 && (t = document.body);
            for (var e = 0, r = Array.from(t.children); e < r.length; e++) {
              var n = r[e];
              n.getAttribute("data-vy-keep-hidden") ? n.setAttribute("aria-hidden", n.getAttribute("data-vy-keep-hidden")) : n.removeAttribute("aria-hidden"), n.removeAttribute("data-vy-keep-hidden");
            }
          }, Be = {
            ios: function() {
              return /ipad|iphone|ipod/i.test(navigator.userAgent);
            }
          }, ae = function(e) {
            for (var r = Array(e.length), n = 0; n < e.length; ++n)
              r[n] = e[n];
            return r;
          }, Bt = function(e, r) {
            return e.filter(function(n) {
              return n === r;
            })[0];
          }, Ee = function(e) {
            return Array.isArray(e) ? e : [e];
          }, je = "data-focus-lock", jt = "data-focus-lock-disabled", Ht = "data-no-focus-lock", qt = "data-autofocus-inside", Wt = function() {
            return document && ae(document.querySelectorAll("[" + Ht + "]")).some(function(e) {
              return e.contains(document.activeElement);
            });
          }, Gt = Wt, $t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
            return typeof t;
          } : function(t) {
            return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          }, zt = function t(e) {
            for (var r = e.length, n = 0; n < r; n += 1)
              for (var a = function(S) {
                if (n !== S && e[n].contains(e[S]))
                  return {
                    v: t(e.filter(function(N) {
                      return N !== e[S];
                    }))
                  };
              }, i = 0; i < r; i += 1) {
                var o = a(i);
                if ((typeof o > "u" ? "undefined" : $t(o)) === "object") return o.v;
              }
            return e;
          }, Kt = function t(e) {
            return e.parentNode ? t(e.parentNode) : e;
          }, Jt = function(e) {
            var r = Ee(e);
            return r.filter(Boolean).reduce(function(n, a) {
              var i = a.getAttribute(je);
              return n.push.apply(n, i ? zt(ae(Kt(a).querySelectorAll("[" + je + '="' + i + '"]:not([' + jt + '="disabled"])'))) : [a]), n;
            }, []);
          }, He = Jt, Xt = function(e) {
            return e === document.activeElement;
          }, Yt = function(e) {
            return !!Bt(ae(e.querySelectorAll("iframe")), Xt);
          }, Qt = function(e) {
            var r = document && document.activeElement;
            return !r || r.dataset && r.dataset.focusGuard ? !1 : He(e).reduce(function(n, a) {
              return n || a.contains(r) || Yt(a);
            }, !1);
          }, Zt = Qt, er = function(e, r) {
            var n = e.tabIndex - r.tabIndex, a = e.index - r.index;
            if (n) {
              if (!e.tabIndex) return 1;
              if (!r.tabIndex) return -1;
            }
            return n || a;
          }, qe = function(e, r, n) {
            return ae(e).map(function(a, i) {
              return {
                node: a,
                index: i,
                tabIndex: a.tabIndex
              };
            }).filter(function(a) {
              return !r || a.tabIndex >= 0;
            }).sort(er);
          }, We = ["button:enabled:not([readonly])", "select:enabled:not([readonly])", "textarea:enabled:not([readonly])", "input:enabled:not([readonly])", "a[href]", "area[href]", "iframe", "object", "embed", "[tabindex]", "[contenteditable]", "[autofocus]"], tr = We.join(","), ke = function(e, r) {
            return e.reduce(function(n, a) {
              return n.concat(
                // add all tabbables inside
                ae(a.querySelectorAll(tr)),
                // add if node is tabble itself
                a.parentNode ? ae(a.parentNode.querySelectorAll(We.join(","))).filter(function(i) {
                  return i === a;
                }) : []
              );
            }, []);
          }, rr = function(e) {
            var r = e.querySelectorAll("[" + qt + "]");
            return ae(r).map(function(n) {
              return ke([n]);
            }).reduce(function(n, a) {
              return n.concat(a);
            }, []);
          }, nr = function(e) {
            return !e || !e.getPropertyValue ? !1 : e.getPropertyValue("display") === "none" || e.getPropertyValue("visibility") === "hidden";
          }, ar = function t(e) {
            return !e || e === document || e.nodeType === Node.DOCUMENT_NODE || !nr(window.getComputedStyle(e, null)) && t(e.parentNode);
          }, ir = function(e) {
            return !((e.tagName === "INPUT" || e.tagName === "BUTTON") && (e.type === "hidden" || e.disabled));
          }, Ge = function t(e) {
            var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
            return r.push(e), e.parentNode && t(e.parentNode, r), r;
          }, Ie = function(e, r) {
            for (var n = Ge(e), a = Ge(r), i = 0; i < n.length; i += 1) {
              var o = n[i];
              if (a.indexOf(o) >= 0)
                return o;
            }
            return !1;
          }, Se = function(e) {
            return ae(e).filter(function(r) {
              return ar(r);
            }).filter(function(r) {
              return ir(r);
            });
          }, $e = function(e, r) {
            return qe(Se(ke(e)), !0);
          }, or = function(e) {
            return qe(Se(ke(e)), !1);
          }, ur = function(e) {
            return Se(rr(e));
          }, Ce = function(e) {
            return e.tagName === "INPUT" && e.type === "radio";
          }, ze = function(e, r) {
            return r.filter(Ce).filter(function(n) {
              return n.name === e.name;
            }).filter(function(n) {
              return n.checked;
            })[0] || e;
          }, sr = function(e) {
            return e[0] && e.length > 1 && Ce(e[0]) && e[0].name ? ze(e[0], e) : e[0];
          }, Ke = function(e, r) {
            return e.length > 1 && Ce(e[r]) && e[r].name ? e.indexOf(ze(e[r], e)) : r;
          }, Je = sr, cr = function(e) {
            return function(r) {
              return !!r.autofocus || r.dataset && !!r.dataset.autofocus || e.indexOf(r) >= 0;
            };
          }, Xe = function(e) {
            return e && e.dataset && e.dataset.focusGuard;
          }, Ae = function(e) {
            return !Xe(e);
          }, lr = function(e, r, n, a, i) {
            var o = e.length, g = e[0], S = e[o - 1], N = Xe(n);
            if (!(e.indexOf(n) >= 0)) {
              var R = r.indexOf(n), z = r.indexOf(a || R), X = e.indexOf(a), Z = R - z, ce = r.indexOf(g), E = r.indexOf(S), P = Ke(e, 0), U = Ke(e, o - 1);
              if (R === -1 || X === -1)
                return e.indexOf(i && i.length ? Je(i) : Je(e));
              if (!Z && X >= 0)
                return X;
              if (R <= ce && N && Math.abs(Z) > 1)
                return U;
              if (R >= ce && N && Math.abs(Z) > 1)
                return P;
              if (Z && Math.abs(Z) > 1)
                return X;
              if (R <= ce)
                return U;
              if (R > E)
                return P;
              if (Z)
                return Math.abs(Z) > 1 ? X : (o + X + Z) % o;
            }
          }, dr = function(e, r, n) {
            var a = Ee(e), i = Ee(r), o = a[0], g = null;
            return i.filter(Boolean).forEach(function(S) {
              g = Ie(g || S, S) || g, n.filter(Boolean).forEach(function(N) {
                var R = Ie(o, N);
                R && (!g || R.contains(g) ? g = R : g = Ie(R, g));
              });
            }), g;
          }, fr = function(e) {
            return e.reduce(function(r, n) {
              return r.concat(ur(n));
            }, []);
          }, vr = function(e, r) {
            var n = /* @__PURE__ */ new Map();
            return r.forEach(function(a) {
              return n.set(a.node, a);
            }), e.map(function(a) {
              return n.get(a);
            }).filter(Boolean);
          }, pr = function(e, r) {
            var n = document && document.activeElement, a = He(e).filter(Ae), i = dr(n || e, e, a), o = $e(a).filter(function(z) {
              var X = z.node;
              return Ae(X);
            });
            if (!(!o[0] && (o = or(a).filter(function(z) {
              var X = z.node;
              return Ae(X);
            }), !o[0]))) {
              var g = $e([i]).map(function(z) {
                var X = z.node;
                return X;
              }), S = vr(g, o), N = S.map(function(z) {
                var X = z.node;
                return X;
              }), R = lr(N, g, n, r, N.filter(cr(fr(a))));
              return R === void 0 ? R : S[R];
            }
          }, hr = pr, mr = function(e) {
            e.focus(), e.contentWindow && e.contentWindow.focus();
          }, Oe = 0, _e = !1, yr = function(t, e) {
            var r = hr(t, e);
            if (!_e && r) {
              if (Oe > 2) {
                console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting"), _e = !0, setTimeout(function() {
                  _e = !1;
                }, 1);
                return;
              }
              Oe++, mr(r.node), Oe--;
            }
          }, gr = yr, Pe = 0, Ye = null, br = function() {
            return document && document.activeElement === document.body;
          }, wr = function() {
            return br() || Gt();
          }, xr = function() {
            var e = !1;
            if (Pe) {
              var r = Pe;
              wr() || (r && !Zt(r) && (e = gr(r, Ye)), Ye = document.activeElement);
            }
            return e;
          }, Er = function(e) {
            return e.filter(function(r) {
              return r;
            }).slice(-1)[0];
          }, kr = function(e) {
            Pe = e, e && xr();
          }, ie = [], be = function(e) {
            return kr(Er(ie)) ? (e && e.preventDefault(), !0) : !1;
          }, Ir = function() {
            document.addEventListener("focusin", be);
          }, Sr = function() {
            document.removeEventListener("focusin", be);
          }, Cr = {
            on: function(e) {
              ie.length === 0 && Ir(), ie.indexOf(e) < 0 && (ie.push(e), be());
            },
            off: function(e) {
              ie = ie.filter(function(r) {
                return r !== e;
              }), be(), ie.length === 0 && Sr();
            }
          }, Qe = Cr, Ar = p(1), Ze = /* @__PURE__ */ p.n(Ar);
          function Or(t, e, r) {
            var n = Nr(t), a = Tr(r), i = Rr(e), o = document.createElement("div");
            return o.id = "vidyard-focusable-element", o.tabIndex = 0, a.popbox.appendChild(n.backerElement), a.popbox.appendChild(n.containingDiv), a.popbox.appendChild(i), Be.ios() && Mt(), document.body.appendChild(a.overlayWrapper), document.body.appendChild(o), a.closeContainer.focus(), Qe.on(a.overlayWrapper), Ze.a.trap(a.overlayWrapper), setTimeout(function() {
              a.overlayWrapper.style.opacity = "1", a.overlayWrapper.style.filter = "alpha(opacity=100)";
            }, 0), {
              container: n,
              lightbox: a
            };
          }
          function _r(t) {
            var e = document.getElementById("vidyard-content-fixed"), r = document.getElementById("vidyard-focusable-element"), n = document.getElementById("vidyard-overlay"), a = document.getElementById("vidyard-overlay-wrapper"), i = document.getElementById("vidyard-popbox");
            if (!(!e || !n || !a || !i)) {
              r && r.parentNode.removeChild(r), Qe.off(a), Ze.a.untrap(a), a.style.opacity = "0", a.style.filter = "alpha(opacity=0)";
              var o = function() {
                a.parentNode.removeChild(a);
              };
              Be.ios() && Dt(), setTimeout(o, ct * 1e3);
            }
          }
          function Pr(t) {
            t.style.opacity = "1";
          }
          function Tr(t) {
            var e = document.createElement("div"), r = document.createElement("div"), n = document.createElement("div"), a = document.createElement("div"), i = Lr().closeContainer;
            return e.id = "vidyard-overlay", e.setAttribute("aria-hidden", "true"), e.style.display = "block", r.id = "vidyard-content-fixed", r.setAttribute("aria-label", "media player lightbox"), r.setAttribute("role", "dialog"), r.style.display = "block", n.id = "vidyard-popbox", a.id = "vidyard-overlay-wrapper", a.style.display = "block", r.appendChild(n), a.appendChild(e), a.appendChild(i), a.appendChild(r), t && (e.style.zIndex = "" + t, r.style.zIndex = "" + (t + 2), i.style.zIndex = "" + (t + 1)), {
              closeContainer: i,
              contentFixed: r,
              overlay: e,
              overlayWrapper: a,
              popbox: n
            };
          }
          function Lr() {
            var t = document.createElement("div"), e = document.createElement("div");
            return t.className = "vidyard-close-container", t.setAttribute("aria-label", "Close Player"), t.setAttribute("role", "button"), t.setAttribute("tabindex", "0"), e.className = "vidyard-close-x", document.documentMode < 9 && (e.className += " simple-close", e.innerHTML = "&times;"), t.appendChild(e), { closeButton: e, closeContainer: t };
          }
          function Nr(t) {
            var e = document.createElement("div");
            e.className = "vidyard-lightbox-content-backer";
            var r = document.createElement("div");
            r.innerHTML = t;
            var n = r.getElementsByTagName("div")[0];
            n.style.position = "absolute", n.style.height = "100%", n.style.width = "100%", n.style.zIndex = "2";
            var a = r.getElementsByTagName("iframe")[0], i = a.parentNode;
            return i.style.position = "static", i.style.paddingBottom = "0", a.style.opacity = "1", setTimeout(function() {
              e.style.opacity = "1", e.style.filter = "alpha(opacity=100)";
            }, 0), {
              backerElement: e,
              containerElement: r,
              containingDiv: n,
              iframe: a
            };
          }
          function Rr(t) {
            var e = y("vidyard-lightbox-image", "img", t)[0].cloneNode();
            return e.className = "", e.id = "vidyard-popbox-constraint", e.alt = "", e.setAttribute("aria-hidden", "true"), e;
          }
          var Te, te = {};
          function Fr(t) {
            var e = y("vidyard-lightbox-centering", "div", t.container)[0];
            t.player.showLightbox = function() {
              Y.setLevel(t.player.uuid)("show lightbox"), Ur({
                container: t.container,
                iframe: t.iframe,
                overlayZindex: t.overlayZindex,
                player: t.player
              });
            }, t.player.hideLightbox = function() {
              return ue(t.player);
            }, h("click", "onclick", t.player.showLightbox, e), h("keydown", "onkeydown", B(function(r) {
              r.preventDefault(), t.player.showLightbox(r);
            }), e);
          }
          function Ur(t) {
            if (!(!t.iframe || document.getElementById("vidyard-overlay"))) {
              Te = document.activeElement;
              var e = Or(t.iframe, t.container, t.overlayZindex);
              t.player.iframe = e.container.iframe, t.player.on("metadata", function o(g) {
                var S = g[0];
                t.player.iframe.title = S.name, t.player.off("metadata", o);
              });
              var r = t.player.uuid, n = e.container.iframe, a = Mr(n, r, t.player), i = Dr(n, r);
              te.iframeLoaded = h("load", "onload", a, e.container.iframe), te.messageHandler = h(
                "message",
                "onmessage",
                // @TODO add better types for data
                Re(function(o) {
                  a(), i(), Vr(o, t.player);
                }),
                window
              ), te.overlayClick = h("click", "onclick", function() {
                return ue(t.player);
              }, e.lightbox.overlayWrapper), te.fixedClick = h("click", "onclick", function() {
                return ue(t.player);
              }, e.lightbox.contentFixed), te.closeKeyPress = h("keydown", "onkeydown", B(function() {
                return ue(t.player);
              }), e.lightbox.closeContainer), te.responsivePlayerSize = h("resize", "onresize", et, window);
            }
          }
          function et() {
            var t = document.getElementById("vidyard-popbox-constraint"), e = parseFloat((window.innerHeight / window.innerWidth * 100).toFixed(2)), r = parseFloat(s(t)), n = e < r ? "landscape" : "portrait";
            t.className !== n && (t.className = n);
          }
          function ue(t) {
            _r(), Te && Te.focus(), Object.keys(te).forEach(function(e) {
              var r = te[e], n = r.eventName, a = r.handler, i = r.element;
              k(n, a, i);
            }), t && t.trigger("lightboxClose");
          }
          function Vr(t, e) {
            t.event === "keyPressed" && t.params === 27 && ue(e);
          }
          function Mr(t, e, r) {
            return C(function() {
              Pr(t), et(), te.parentEsc = h("keydown", "onkeydown", W(function() {
                return ue(r);
              }), document);
            });
          }
          function Dr(t, e) {
            return C(function() {
              var r = { uuid: e, event: "listenForKeyPress", keyCode: "27" };
              de(r, "https://" + J(), t);
            });
          }
          var Br = Object.assign || function(t) {
            for (var e, r = 1, n = arguments.length; r < n; r++) {
              e = arguments[r];
              for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
            }
            return t;
          };
          function tt(t) {
            if (!t || typeof t != "string" || t.length < 20)
              throw new Error("Invalid UUID given");
            var e = Y.setLevel(t), r = "https://" + J() + "/player/" + t + ".json?pomo=0&pomo_reason=fetchMetaData";
            return e("fetching metadata"), O({ endpoint: r }).then(JSON.parse).then(function(n) {
              return e("metadata successfully fetched"), Br({ uuid: t }, n.payload.vyContext.metadata);
            }).catch(function(n) {
              throw e("failed to fetch metadata, " + n), new Error("Error parsing player metadata, make sure the UUID is correct");
            });
          }
          function jr(t, e, r) {
            var n = "https://" + J() + "/" + e.uuid + ".jpg", a = qr(n, e, r);
            t.insertAdjacentHTML("afterbegin", a), tt(e.uuid).then(function(i) {
              var o = y("play-button", "button", t);
              o.length === 1 && o[0].setAttribute("aria-label", "Play video " + i.name + ". Opens in a modal");
            }, function() {
            });
          }
          function Hr(t, e) {
            if (t.pb === 1) {
              var r = y("play-button", "button", e);
              r.length === 1 && (r[0].style.display = "block", r[0].style.backgroundColor = "#" + t.pbc);
            }
          }
          function qr(t, e, r) {
            return '<div class="vidyard-lightbox-thumbnail vidyard-lightbox-' + e.uuid + '"' + (r.maxWidth ? ' style="max-width: ' + r.maxWidth + 'px;"' : "") + '><div class="vidyard-lightbox-centering" style="padding-bottom: ' + r.ratio + '%;"><img class="vidyard-lightbox-image" src="' + t + '" alt="video thumbnail" /><div type="button" role="button" class="play-button" title="Play video" data-version="1" tabindex="0"><div class="play-button-size"></div><div class="arrow-size"><div class="arrow-size-ratio"></div><div class="arrow"></div></div></div></div></div>';
          }
          var Wr = function(t) {
            var e = t.dataParams, r = t.player, n = Y.setLevel(e.uuid);
            n("injecting lighbox embed"), r.placeholder.style.display = "none";
            var a = { ratio: s(r.placeholder) }, i = Ve(e, a), o = {
              maxHeight: e.height ? parseInt(e.height, 10) : null,
              maxWidth: e.width ? parseInt(e.width, 10) : null,
              ratio: s(r.placeholder)
            };
            jr(r.container, e, o), Fr({
              container: r.container,
              iframe: i,
              overlayZindex: e.overlayZindex,
              player: r
            }), n("getStyle sent"), Me(r.uuid).then(function(g) {
              n("getStyle received: " + JSON.stringify(g)), Hr(g, r.container);
            }).catch(function(g) {
              n("getStyle failed, likely a network error");
            });
          }, Gr = Wr, $r = /(vidyard|vystaging|hubspot)\.com$/, zr = function(t, e, r) {
            if (r === void 0 && (r = !1), !(!r && (!e || !e.hasBacklink || $r.test(document.location.host)))) {
              var n = document.createElement("a"), a = document.createElement("span"), i = document.createElement("img");
              i.src = "https://cdn.vidyard.com/client-logos/vidyard.png", i.id = "backlink-icon", i.alt = "Vidyard Logo", a.id = "backlink-text", a.textContent = "Powered by Vidyard", n.id = "backlink", n.appendChild(i), n.appendChild(a), n.href = e.backlinkURL, n.rel = "nofollow", n.target = "_blank", n.setAttribute("aria-label", "Link to Vidyard"), n.dataset.testid = "backlink", h("click", "onclick", function() {
                var o = {
                  data: {
                    event: "Acquisition - Clicked the Backlink"
                  },
                  event: "sendMetricsEvent",
                  uuid: t.uuid
                };
                de(o, "https://" + J(), t.iframe);
              }, n), t.container.appendChild(n);
            }
          }, Kr = zr;
          function Jr(t) {
            var e = window.VidyardV4.integrations, r = Y.setLevel(t.uuid), n = e.getCookie("marketo");
            n && (r("getMarketoLead sent"), Tt(t.uuid, n).then(f).then(function(a) {
              r("getMarketoLead received: " + a), t.on("ready", function() {
                e.addKnownVisitor("marketo", a, t.org);
              });
            }).catch(function() {
              Y.warn("Invalid Marketo cookie");
            })), r("getIntegrations"), _t(t.uuid).then(function(a) {
              r("getIntegrations received: " + JSON.stringify(a)), t.on("ready", function() {
                t._tmpOrg = a, e.updatePlayer(t);
              });
            }).catch(function(a) {
              r("getIntegrations failed, likely a network error");
            });
          }
          function Xr(t) {
            var e = Y.setLevel(t);
            return e("getSEO sent"), Pt(t).then(function(r) {
              if (e("getSEO: " + JSON.stringify(r)), !_(r)) {
                var n = Ot(r);
                document.getElementsByTagName("head")[0].appendChild(n);
              }
              return r;
            }).catch(function(r) {
              e("getSEO failed, likely a network error");
            });
          }
          var Yr = function(t, e) {
            var r = document.createElement("div");
            r.className = "vidyard-player-container", r.setAttribute("uuid", t);
            var n = r.style;
            return n.margin = "auto", n.width = "100%", n.height = "auto", n.overflow = "hidden", n.display = "block", e.type === "inline" && (n.maxWidth = e.width ? e.width + "px" : "", n.maxHeight = e.height ? e.height + "px" : ""), r;
          }, Qr = Yr, Zr = (
            /** @class */
            function() {
              function t(e) {
                var r = this;
                this.disable_popouts = 1;
                var n = ee(j(e));
                Object.keys(n).forEach(function(o) {
                  r[o] = n[o];
                }), this.type !== "inline" && this.type !== "lightbox" && (c("Invalid Vidyard player embed type, defaulting to inline.", "warn"), this.type = "inline"), this.v = re, this.disable_popouts = 1, this.custom_id = this.custom_id || D("vycustom_id"), this.vyemail = this.vyemail || D("vyemail"), this.vysfid = this.vysfid || D("vysfid"), this.vyetoken = this.vyetoken || D("vyetoken");
                var a = D("vyac"), i = D("vyplayer");
                a && i && i === this.uuid ? this.access_code = a : a && i && c("Invalid Vidyard player access code.", "warn");
              }
              return t.prototype.toQueryString = function() {
                var e = "?", r;
                for (r in this)
                  this.hasOwnProperty(r) && (r === "height" || r === "uuid" || r === "width" || this[r] !== void 0 && (e += e !== "?" ? "&" : "", e += encodeURIComponent(r) + "=" + encodeURIComponent(this[r])));
                return e === "?" ? "" : e;
              }, t;
            }()
          ), rt = Zr;
          function en(t) {
            t === void 0 && (t = y("vidyard-player-embed", "img"));
            for (var e = 0, r = t; e < r.length; e++) {
              var n = r[e], a = new rt(n), i = a.uuid, o = "https://" + J() + "/" + i + a.toQueryString();
              i && x(o, window.VidyardV4.preloadLinks) === -1 && (tn(i, o), window.VidyardV4.preloadLinks.push(o));
            }
          }
          function tn(t, e) {
            var r = document.createElement("link");
            return r.rel = "prefetch", r.crossOrigin = "anonymous", r.href = e, document.body.appendChild(r), e;
          }
          var rn = Object.assign || function(t) {
            for (var e, r = 1, n = arguments.length; r < n; r++) {
              e = arguments[r];
              for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
            }
            return t;
          }, nn = (
            /** @class */
            function() {
              function t(e, r, n) {
                var a = this;
                this._ready = !1, this._previousTime = null, this._onMessageEventHandler = function(i) {
                  if (i.origin === "https://" + J()) {
                    var o;
                    try {
                      o = JSON.parse(i.data);
                    } catch {
                      return;
                    }
                    if (!(a.iframe && i.source && a.iframe.contentWindow !== i.source) && !(a.uuid && o.uuid !== a.uuid) && typeof o.event == "string") {
                      a._updateStatus(o), o.event === "ready" && (a._ready = !0, window.VidyardV4.integrations.updatePlayer(a));
                      var g = a._callbackStore[o.event];
                      if (g)
                        for (var S = 0, N = g; S < N.length; S++) {
                          var R = N[S];
                          R.call(a, o.params, a);
                        }
                    }
                  }
                }, this._callbackStore = n || {
                  beforeSeek: [],
                  chapterComplete: [],
                  createCta: [],
                  fullScreenChange: [],
                  lightboxClose: [],
                  metadata: [],
                  pause: [],
                  play: [],
                  playerComplete: [],
                  ready: [],
                  seek: [],
                  sidePlaylistOpen: [],
                  status: [],
                  timeupdate: [],
                  videoComplete: [],
                  volumeChange: []
                }, this.element = e, this.uuid = r, this.status = null, this.metadata = null, this.progressEventsUnsubscribe = [], h("message", "onmessage", this._onMessageEventHandler);
              }
              return t.prototype.on = function(e, r) {
                var n = this;
                if (e === "ready" && this.ready()) {
                  setTimeout(function() {
                    return r.call(n, void 0, n);
                  }, 0);
                  return;
                }
                if (this._callbackStore[e] === void 0) {
                  this._callbackStore[e] = [r], c("The event name: " + e + " is not supported, your handler was setup regardless", "warn");
                  return;
                }
                this._callbackStore[e].push(r);
              }, t.prototype.trigger = function(e) {
                for (var r = this, n = [], a = 1; a < arguments.length; a++)
                  n[a - 1] = arguments[a];
                for (var i = function(R) {
                  e === "ready" && o.ready() ? setTimeout(function() {
                    return R.call(r, n, r);
                  }, 0) : R.call(o, n, o);
                }, o = this, g = 0, S = this._callbackStore[e]; g < S.length; g++) {
                  var N = S[g];
                  i(N);
                }
              }, t.prototype.off = function(e, r) {
                if (e === void 0) {
                  for (var n in this._callbackStore)
                    this._callbackStore.hasOwnProperty(n) && (this._callbackStore[n] = []);
                  return;
                }
                if (this._callbackStore[e])
                  if (r) {
                    var a = x(r, this._callbackStore[e]);
                    a > -1 && this._callbackStore[e].splice(a, 1);
                  } else
                    this._callbackStore[e] = [];
              }, t.prototype.ready = function() {
                return this._ready;
              }, t.prototype.play = function() {
                this._message({ event: "play" });
              }, t.prototype.pause = function() {
                this._message({ event: "pause" });
              }, t.prototype.resume = function() {
                this._message({ event: "resume" });
              }, t.prototype.seek = function(e) {
                this._message({ event: "seek", position: e });
              }, t.prototype.setVolume = function(e) {
                this._message({ event: "setVolume", newVolume: e });
              }, t.prototype.setPlaybackSpeed = function(e) {
                this._message({ event: "setPlaybackSpeed", speed: e });
              }, t.prototype.playChapter = function(e) {
                c("playChapter() is deprecated. We recommend to use playVideoAtIndex() instead."), this.playVideoAtIndex(e);
              }, t.prototype.playVideoAtIndex = function(e) {
                this._message({ chapter_index: e, event: "playChapter" });
              }, t.prototype.setAudioTrack = function(e) {
                this._message({ audioTrackId: e, event: "setAudioTrack" });
              }, t.prototype.enableCaption = function(e, r) {
                this._message({ event: "enableCaption", label: e, language: r });
              }, t.prototype.disableCaption = function(e, r) {
                this._message({ event: "disableCaption", label: e, language: r });
              }, t.prototype.consentToGDPR = function(e) {
                this._message({ consent: e, event: "consentToGDPR" });
              }, t.prototype.createCta = function(e) {
                this._message({
                  attributes: A({
                    display_once: !1,
                    duration: 10,
                    fullscreen: !1,
                    html: "",
                    opacity: 1,
                    start: 0,
                    width: 300
                  }, e),
                  event: "createCta"
                });
              }, t.prototype.updateCta = function(e, r) {
                this._message({
                  attributes: r,
                  event: "updateCta",
                  id: e
                });
              }, t.prototype.createVideoSection = function(e, r) {
                this._message({ event: "createVideoSection", title: e, milliseconds: r });
              }, t.prototype.updateVideoSection = function(e, r, n) {
                this._message({ event: "updateVideoSection", index: e, title: r, milliseconds: n });
              }, t.prototype.deleteVideoSection = function(e) {
                this._message({ event: "deleteVideoSection", index: e });
              }, t.prototype.addEvent = function(e) {
                var r = e.start, n = r === void 0 ? 0 : r, a = e.duration, i = a === void 0 ? 1 : a, o = e.videoIndex, g = e.chapterIndex, S = e.eventId;
                if (!S) {
                  c("Missing arguments. Need eventId");
                  return;
                }
                g >= 0 && c("Parameter chapterIndex is deprecated. We recommend to use videoIndex instead.");
                var N = 0;
                N = g || N, N = o || N, this._message({
                  chapterIndex: N,
                  duration: i,
                  event: "addEvent",
                  id: S,
                  start: n
                });
              }, t.prototype.getCurrentChapter = function() {
                return c("getCurrentChapter() is deprecated. We recommend to use getCurrentVideoIndex() instead."), this.getCurrentVideoIndex();
              }, t.prototype.getCurrentVideoIndex = function() {
                return this.status === null ? null : this.status.chapterIndex;
              }, t.prototype.currentTime = function() {
                return this.status === null ? null : this.status.currentTime;
              }, t.prototype.scrubbing = function() {
                return this.status === null ? null : this.status.scrubbing;
              }, t.prototype.toggleFullscreen = function() {
                var e = this, r = V();
                if (r) {
                  var n = this.iframe[r.requestFullscreen]();
                  n ? n.then(function() {
                    e._message({ event: "toggleFullscreen" });
                  }) : this._message({ event: "toggleFullscreen" }), h(r.fullscreenchange, "MSFullscreenChange", function() {
                    document[r.fullscreenElement] || e._message({ event: "exitFullscreen" });
                  }), h("message", "onmessage", Re(function(a) {
                    a.event === "fullScreenChange" && a.params === !1 && document[r.fullscreenElement] && document[r.exitFullscreen]();
                  }));
                } else
                  this._message({ event: "toggleFullscreen" });
              }, t.prototype.resetPlayer = function() {
                this._message({ event: "resetPlayer" });
              }, t.prototype._message = function(e) {
                if (this.ready() !== !0) {
                  c("Player is not ready yet! No messages can be recieved.", "error");
                  return;
                }
                de(rn({}, e, { uuid: this.uuid }), "https://" + J(), this.iframe);
              }, t.prototype._updateStatus = function(e) {
                if (typeof e.status == "object" && (this.status = e.status), typeof e.metadata == "object" && (this.metadata = e.metadata, this.trigger("metadata", e.metadata)), this.status) {
                  if (this.status.currentTime !== this._previousTime && this._callbackStore.timeupdate)
                    for (var r = 0, n = this._callbackStore.timeupdate; r < n.length; r++) {
                      var a = n[r];
                      a.call(this, this.status.currentTime, this);
                    }
                  this._previousTime = this.status.currentTime;
                }
              }, t;
            }()
          ), an = nn, on = function(t) {
            t === void 0 && (t = document);
            var e = y("vidyard-player-embed", "img", t);
            en(e), l(e).forEach(nt), Ue();
          }, nt = function(t) {
            var e = window.VidyardV4;
            e.integrations, e.api;
            var r = e.players;
            e.playerReadyListeners;
            var n = new rt(t), a = n.uuid, i = Y.setLevel(a);
            if (i("rendering"), a === void 0) {
              c('Embed without a UUID detected, it is impossible to insert a player without a UUID. Add "data-uuid=some_uuid" to the offending element.' + t);
              return;
            }
            if (n.rendered === "true")
              return i("Already rendered"), w(r, function(S) {
                return S.placeholder === t;
              });
            var o = Qr(a, n), g = new an(o, a);
            return t.setAttribute("data-rendered", "true"), t.parentNode.insertBefore(o, t), g.placeholder = t, g.container = o, r.push(g), Ct(g), n.type === "inline" ? Vt({ dataParams: n, player: g }) : n.type === "lightbox" && Gr({ dataParams: n, player: g }), Jr(g), Xr(g.uuid).then(function(S) {
              n.type === "inline" && Kr(g, S, n.backlink && n.backlink === 1);
            }), window.Vidyard._players[g.uuid] = g, g;
          };
          function un(t) {
            t.progressEventsUnsubscribe.forEach(function(e) {
              return e();
            }), t.progressEventsUnsubscribe = [];
          }
          function sn(t) {
            var e = window.VidyardV4.players;
            u(e, t) ? (un(t), t.off(), t.container.parentNode.removeChild(t.container), t.placeholder.parentNode.removeChild(t.placeholder), e.splice(x(t, e))) : c("Cannot destroy an unknown player", "warn");
          }
          function cn(t) {
            if (t !== void 0)
              for (var e = window.VidyardV4.players, r = function(o) {
                o.on("ready", function() {
                  o.consentToGDPR(t);
                });
              }, n = 0, a = e; n < a.length; n++) {
                var i = a[n];
                r(i);
              }
          }
          function ln(t) {
            var e = 0, r = window.VidyardV4.api.GDPR, n = window.VidyardV4.players;
            if (n.length === 0)
              return t(!1);
            if (r._readyConsent !== void 0)
              return t(r._readyConsent);
            for (var a = 0, i = n; a < i.length; a++) {
              var o = i[a];
              o.on("ready", function() {
                if (e !== n.length && (e += 1), e === n.length)
                  return r._readyConsent = n.reduce(function(g, S) {
                    return S.status.consent && g;
                  }, !0), t(r._readyConsent);
              });
            }
          }
          function dn(t) {
            return window.VidyardV4.players.filter(function(e) {
              return e.uuid === t;
            });
          }
          var fn = dn, vn = function(t) {
            t.sort(function(r, n) {
              return r < n ? -1 : r > n ? 1 : 0;
            });
            for (var e = 0; e < t.length; )
              t[e] === t[e + 1] ? t.splice(e + 1, 1) : e += 1;
            return t;
          }, fe = {}, se = {};
          function pn(t, e, r) {
            typeof se[t.uuid] != "object" && (se[t.uuid] = {}), fe[t.uuid] = {
              callback: e,
              thresholds: r.slice().sort(function(n, a) {
                return a - n;
              })
            };
          }
          function hn(t, e) {
            yn(t, e, fe[t.uuid].callback, fe[t.uuid].thresholds.slice());
          }
          function mn(t, e) {
            if (typeof fe[t.uuid] == "object")
              return typeof se[t.uuid][e] != "object" && hn(t, e), se[t.uuid][e];
          }
          function yn(t, e, r, n) {
            se[t.uuid][e] = {
              callback: r,
              lastTimeUpdate: t.currentTime(),
              partOfVideoWatched: {},
              player: t,
              thresholds: n,
              timeWatched: 0
            };
          }
          function gn(t) {
            fe[t.uuid] = void 0, se[t.uuid] = void 0;
          }
          function bn(t, e) {
            var r = t.getCurrentVideoIndex(), n = mn(t, r);
            if (!(typeof n > "u" || typeof n.player.metadata != "object" || n.thresholds.length === 0)) {
              var a = e - n.lastTimeUpdate;
              if (n.lastTimeUpdate = e, !(a <= 0 || a > 1)) {
                e >= 1 && (n.partOfVideoWatched[Math.floor(e)] = 1), n.timeWatched = Object.keys(n.partOfVideoWatched).length;
                for (var i = n.player.metadata.chapters_attributes[r].video_attributes.length_in_milliseconds, o = Math.floor(i / 1e3), g = n.timeWatched / o * 100; g >= n.thresholds[n.thresholds.length - 1]; )
                  n.callback({
                    // Deprecated. Only included for backwards compatibility
                    chapter: r,
                    event: n.thresholds.pop(),
                    player: t,
                    videoIndex: r
                  });
              }
            }
          }
          function wn(t, e, r) {
            pn(t, e, r);
            var n = function(a) {
              return bn(t, a);
            };
            return t.on("timeupdate", n), {
              player: t,
              removeEventListeners: function() {
                t.off("timeupdate", n), gn(t);
              }
            };
          }
          function xn(t, e, r) {
            var n;
            e === void 0 && (e = [1, 25, 50, 75, 90]);
            var a = [], i = r ? (n = {}, n[r.uuid] = r, n) : En(), o = vn(e), g = function(N) {
              if (i.hasOwnProperty(N) && N.length > 0 && i[N] !== "") {
                var R = wn(i[N], t, o);
                a.push(R);
              } else
                c(function() {
                  return console.error("Could not attach Progress Events to player " + N + ", make sure to load the Vidyard Player API");
                });
            };
            for (var S in i)
              g(S);
            return a.length === 0 && c(function() {
              return console.warn("No Vidyard Players found. (include this script below player embed codes)");
            }), a;
          }
          function En() {
            try {
              return window.Vidyard.players();
            } catch {
              return c(function() {
                return console.error("The Vidyard Player API must be loaded before this script can execute");
              }), {};
            }
          }
          function kn() {
            for (var t = [], e = 0; e < arguments.length; e++)
              t[e] = arguments[e];
            var r = xn.apply(void 0, t);
            Object.keys(r).forEach(function(n) {
              var a = r[n], i = a.player, o = a.removeEventListeners;
              i.progressEventsUnsubscribe && i.progressEventsUnsubscribe.push(o);
            });
          }
          var In = function(t) {
            Y.setLevel("placeholder")("rendering player from placeholder image");
            var e = nt(t);
            return new d(function(r) {
              e.showLightbox ? r(e) : e.on("ready", function() {
                return r(e);
              });
            });
          };
          function Sn(t) {
            var e = t instanceof HTMLImageElement ? t : Rt(t);
            return De(e).then(In).catch(function(r) {
              return c(ge.errors.placeholder, "warn");
            });
          }
          var Cn = {
            _debug: It,
            api: {
              GDPR: { consent: cn, hasConsentOnReady: ln },
              addReadyListener: St,
              destroyPlayer: sn,
              getPlayerMetadata: tt,
              getPlayersByUUID: fn,
              progressEvents: kn,
              renderDOMPlayers: on,
              renderPlayer: Sn
            },
            integrations: new yt(),
            jsonp: {},
            // Just ensure that the undefined uuid option is always present
            playerReadyListeners: { undefined: [] },
            players: [],
            preloadLinks: []
          }, ve = Cn, An = {
            _players: {},
            players: function() {
              return window.VidyardV4.players.reduce(function(t, e) {
                return t[e.uuid] = e, t;
              }, {});
            }
          }, On = An;
          p(12);
          var _n = p(2);
          function Pn(t) {
            var e = t.error, r = t.location, n = t.message, a = t.navigator, i = t.timeStamp, o = t.type, g = t.vyGlobal;
            return {
              data: {
                // Required: body
                // The main data being sent. It can either be a message, an exception, or a crash report.
                body: {
                  // If this payload is a single exception, use "trace"
                  // A list of stack frames, ordered such that the most recent call is last in the list.
                  trace: {
                    // Required: exception
                    // An object describing the exception instance.
                    exception: {
                      // Required: class
                      // The exception class name.
                      class: e.name,
                      // Optional: message
                      // The exception message, as a string
                      message: n
                    },
                    // Each frame is an object.
                    frames: _n.parse(e).map(function(S) {
                      return {
                        // Optional: code
                        // The line of code
                        code: S.source,
                        // Optional: colno
                        // The column number as an integer
                        colno: S.columnNumber,
                        // Required: filename
                        // The filename including its full path.
                        filename: S.fileName,
                        // Optional: colno
                        // The column number as an integer
                        lineno: S.lineNumber,
                        // Optional: method
                        // The method or function name
                        method: S.functionName
                      };
                    })
                  }
                },
                // Optional: client
                // Data about the client device this event occurred on.
                // As there can be multiple client environments for a given event (i.e. Flash running inside
                // an HTML page), data should be namespaced by platform.
                client: {
                  // Can contain any arbitrary keys. Rollbar understands the following:
                  // Optional: cpu
                  // A string up to 255 characters
                  cpu: a.platform,
                  javascript: {
                    // Optional: browser
                    // The user agent string
                    browser: a.userAgent,
                    // Optional: guess_uncaught_frames
                    // Set to true to enable frame guessing
                    // See the "Source Maps" guide for more details.
                    guess_uncaught_frames: !0,
                    // Optional: source_map_enabled
                    // Set to true to enable source map deobfuscation
                    // See the "Source Maps" guide for more details.
                    source_map_enabled: !0
                  }
                },
                // Optional: code_version
                // A string, up to 40 characters, describing the version of the application code
                // Rollbar understands these formats:
                // - semantic version (i.e. "2.1.12")
                // - integer (i.e. "45")
                // - git SHA (i.e. "3da541559918a808c2402bba5012f6c60b27661c")
                code_version: re,
                // Optional: custom
                // Any arbitrary metadata you want to send. "custom" itself should be an object.
                custom: {
                  jsonpRequests: Object.keys(g.jsonp),
                  playbackUrlOverride: window.VIDYARD_PLAYBACK_URL,
                  players: g.players.map(function(S) {
                    return {
                      iframe: S.iframe ? { src: S.iframe.src } : {},
                      metadata: S.metadata,
                      org: S.org ? { id: S.org.id, foundIntegrations: S.org.foundIntegrations } : {},
                      uuid: S.uuid
                    };
                  }),
                  preloadLinks: g.preloadLinks
                },
                // Required: environment
                // The name of the environment in which this occurrence was seen.
                // A string up to 255 characters. For best results, use "production" or "prod" for your
                // production environment.
                // You don't need to configure anything in the Rollbar UI for new environment names;
                // we'll detect them automatically.
                environment: J(),
                // Optional: fingerprint
                // A string controlling how this occurrence should be grouped. Occurrences with the same
                // fingerprint are grouped together. See the "Grouping" guide for more information.
                // Should be a string up to 40 characters long; if longer than 40 characters, we'll use its SHA1 hash.
                // If omitted, we'll determine this on the backend.
                fingerprint: e.name,
                // Optional: language
                // The name of the language your code is written in.
                // This can affect the order of the frames in the stack trace. The following languages set the most
                // recent call first - 'ruby', 'javascript', 'php', 'java', 'objective-c', 'lua'
                // It will also change the way the individual frames are displayed, with what is most consistent with
                // users of the language.
                language: "javascript",
                // Optional: level
                // The severity level. One of: "critical", "error", "warning", "info", "debug"
                // Defaults to "error" for exceptions and "info" for messages.
                // The level of the *first* occurrence of an item is used as the item's level.
                level: o,
                // Optional: platform
                // The platform on which this occurred. Meaningful platform names:
                // "browser", "android", "ios", "flash", "client", "heroku", "google-app-engine"
                // If this is a client-side event, be sure to specify the platform and use a post_client_item access token.
                platform: "browser",
                // Optional: request
                // Data about the request this event occurred in.
                // Can contain any arbitrary keys. Rollbar understands the following:
                // query_string: the raw query string
                // url: full URL where this event occurred
                request: { query_string: r.search, url: r.href },
                // Optional: timestamp
                // When this occurred, as a unix timestamp.
                timestamp: i
              }
            };
          }
          var at = function(t) {
            return t === void 0 && (t = ""), t.match(ne);
          }, it = function(t) {
            var e = t.error, r = t.filename, n = t.message, a = t.timeStamp, i = t.type;
            if (at(r)) {
              var o = window.location, g = window.navigator, S = window.VidyardV4, N = Pn({
                error: e,
                location: o,
                message: n,
                navigator: g,
                timeStamp: a,
                type: i,
                vyGlobal: S
              });
              O({ endpoint: pt(), method: "POST", payload: N }).then(function(R) {
                return c("Error logged " + R);
              }, function(R) {
                return c("Error log failed " + R);
              });
            }
          };
          function Tn() {
            h("error", "onerror", it, window), h("unhandledrejection", "", function(t) {
              var e = t.reason, r = t.timeStamp, n = t.type;
              t.reason instanceof Error && at(e.stack) && (t.preventDefault(), it({
                error: e,
                // PromiseRejectionEvents do not have a filename field
                // the workaround is to look for the v4.js script in the stack trace
                filename: e.stack,
                message: e.message,
                timeStamp: r,
                type: n
              }));
            });
          }
          p.d(T, "_debug", function() {
            return Ln;
          }), p.d(T, "api", function() {
            return Nn;
          }), p.d(T, "players", function() {
            return Rn;
          }), Tn(), window.VidyardV4 = window.VidyardV4 || ve, window.Vidyard = window.Vidyard || On, Ue();
          var Ln = ve._debug, Nn = ve.api, Rn = ve.players;
          T.default = ve;
        },
        /* 7 */
        /***/
        function(M, T, p) {
          var v, b, m;
          (function(I, d) {
            b = [], v = d, m = typeof v == "function" ? v.apply(T, b) : v, m !== void 0 && (M.exports = m);
          })(this, function() {
            function I(u) {
              return !isNaN(parseFloat(u)) && isFinite(u);
            }
            function d(u) {
              return u.charAt(0).toUpperCase() + u.substring(1);
            }
            function h(u) {
              return function() {
                return this[u];
              };
            }
            var k = ["isConstructor", "isEval", "isNative", "isToplevel"], L = ["columnNumber", "lineNumber"], _ = ["fileName", "functionName", "source"], x = ["args"], A = k.concat(L, _, x);
            function y(u) {
              if (u instanceof Object)
                for (var C = 0; C < A.length; C++)
                  u.hasOwnProperty(A[C]) && u[A[C]] !== void 0 && this["set" + d(A[C])](u[A[C]]);
            }
            y.prototype = {
              getArgs: function() {
                return this.args;
              },
              setArgs: function(u) {
                if (Object.prototype.toString.call(u) !== "[object Array]")
                  throw new TypeError("Args must be an Array");
                this.args = u;
              },
              getEvalOrigin: function() {
                return this.evalOrigin;
              },
              setEvalOrigin: function(u) {
                if (u instanceof y)
                  this.evalOrigin = u;
                else if (u instanceof Object)
                  this.evalOrigin = new y(u);
                else
                  throw new TypeError("Eval Origin must be an Object or StackFrame");
              },
              toString: function() {
                var u = this.getFunctionName() || "{anonymous}", C = "(" + (this.getArgs() || []).join(",") + ")", B = this.getFileName() ? "@" + this.getFileName() : "", W = I(this.getLineNumber()) ? ":" + this.getLineNumber() : "", $ = I(this.getColumnNumber()) ? ":" + this.getColumnNumber() : "";
                return u + C + B + W + $;
              }
            };
            for (var s = 0; s < k.length; s++)
              y.prototype["get" + d(k[s])] = h(k[s]), y.prototype["set" + d(k[s])] = /* @__PURE__ */ function(u) {
                return function(C) {
                  this[u] = !!C;
                };
              }(k[s]);
            for (var c = 0; c < L.length; c++)
              y.prototype["get" + d(L[c])] = h(L[c]), y.prototype["set" + d(L[c])] = /* @__PURE__ */ function(u) {
                return function(C) {
                  if (!I(C))
                    throw new TypeError(u + " must be a Number");
                  this[u] = Number(C);
                };
              }(L[c]);
            for (var w = 0; w < _.length; w++)
              y.prototype["get" + d(_[w])] = h(_[w]), y.prototype["set" + d(_[w])] = /* @__PURE__ */ function(u) {
                return function(C) {
                  this[u] = String(C);
                };
              }(_[w]);
            return y;
          });
        },
        /* 8 */
        /***/
        function(M, T) {
          M.exports = function(p) {
            var v = typeof window < "u" && window.location;
            if (!v)
              throw new Error("fixUrls requires window.location");
            if (!p || typeof p != "string")
              return p;
            var b = v.protocol + "//" + v.host, m = b + v.pathname.replace(/\/[^\/]*$/, "/"), I = p.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(d, h) {
              var k = h.trim().replace(/^"(.*)"$/, function(_, x) {
                return x;
              }).replace(/^'(.*)'$/, function(_, x) {
                return x;
              });
              if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(k))
                return d;
              var L;
              return k.indexOf("//") === 0 ? L = k : k.indexOf("/") === 0 ? L = b + k : L = m + k.replace(/^\.\//, ""), "url(" + JSON.stringify(L) + ")";
            });
            return I;
          };
        },
        /* 9 */
        /***/
        function(M, T, p) {
          var v = {}, b = function(l) {
            var f;
            return function() {
              return typeof f > "u" && (f = l.apply(this, arguments)), f;
            };
          }, m = b(function() {
            return window && document && document.all && !window.atob;
          }), I = function(l) {
            return document.querySelector(l);
          }, d = /* @__PURE__ */ function(l) {
            var f = {};
            return function(O) {
              if (typeof O == "function")
                return O();
              if (typeof f[O] > "u") {
                var V = I.call(this, O);
                if (window.HTMLIFrameElement && V instanceof window.HTMLIFrameElement)
                  try {
                    V = V.contentDocument.head;
                  } catch {
                    V = null;
                  }
                f[O] = V;
              }
              return f[O];
            };
          }(), h = null, k = 0, L = [], _ = p(8);
          M.exports = function(l, f) {
            if (typeof DEBUG < "u" && DEBUG && typeof document != "object")
              throw new Error("The style-loader cannot be used in a non-browser environment");
            f = f || {}, f.attrs = typeof f.attrs == "object" ? f.attrs : {}, !f.singleton && typeof f.singleton != "boolean" && (f.singleton = m()), f.insertInto || (f.insertInto = "head"), f.insertAt || (f.insertAt = "bottom");
            var O = A(l, f);
            return x(O, f), function(j) {
              for (var D = [], H = 0; H < O.length; H++) {
                var ee = O[H], K = v[ee.id];
                K.refs--, D.push(K);
              }
              if (j) {
                var re = A(j, f);
                x(re, f);
              }
              for (var H = 0; H < D.length; H++) {
                var K = D[H];
                if (K.refs === 0) {
                  for (var ne = 0; ne < K.parts.length; ne++) K.parts[ne]();
                  delete v[K.id];
                }
              }
            };
          };
          function x(l, f) {
            for (var O = 0; O < l.length; O++) {
              var V = l[O], j = v[V.id];
              if (j) {
                j.refs++;
                for (var D = 0; D < j.parts.length; D++)
                  j.parts[D](V.parts[D]);
                for (; D < V.parts.length; D++)
                  j.parts.push(C(V.parts[D], f));
              } else {
                for (var H = [], D = 0; D < V.parts.length; D++)
                  H.push(C(V.parts[D], f));
                v[V.id] = { id: V.id, refs: 1, parts: H };
              }
            }
          }
          function A(l, f) {
            for (var O = [], V = {}, j = 0; j < l.length; j++) {
              var D = l[j], H = f.base ? D[0] + f.base : D[0], ee = D[1], K = D[2], re = D[3], ne = { css: ee, media: K, sourceMap: re };
              V[H] ? V[H].parts.push(ne) : O.push(V[H] = { id: H, parts: [ne] });
            }
            return O;
          }
          function y(l, f) {
            var O = d(l.insertInto);
            if (!O)
              throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
            var V = L[L.length - 1];
            if (l.insertAt === "top")
              V ? V.nextSibling ? O.insertBefore(f, V.nextSibling) : O.appendChild(f) : O.insertBefore(f, O.firstChild), L.push(f);
            else if (l.insertAt === "bottom")
              O.appendChild(f);
            else if (typeof l.insertAt == "object" && l.insertAt.before) {
              var j = d(l.insertInto + " " + l.insertAt.before);
              O.insertBefore(f, j);
            } else
              throw new Error(`[Style Loader]

 Invalid value for parameter 'insertAt' ('options.insertAt') found.
 Must be 'top', 'bottom', or Object.
 (https://github.com/webpack-contrib/style-loader#insertat)
`);
          }
          function s(l) {
            if (l.parentNode === null) return !1;
            l.parentNode.removeChild(l);
            var f = L.indexOf(l);
            f >= 0 && L.splice(f, 1);
          }
          function c(l) {
            var f = document.createElement("style");
            return l.attrs.type === void 0 && (l.attrs.type = "text/css"), u(f, l.attrs), y(l, f), f;
          }
          function w(l) {
            var f = document.createElement("link");
            return l.attrs.type === void 0 && (l.attrs.type = "text/css"), l.attrs.rel = "stylesheet", u(f, l.attrs), y(l, f), f;
          }
          function u(l, f) {
            Object.keys(f).forEach(function(O) {
              l.setAttribute(O, f[O]);
            });
          }
          function C(l, f) {
            var O, V, j, D;
            if (f.transform && l.css)
              if (D = f.transform(l.css), D)
                l.css = D;
              else
                return function() {
                };
            if (f.singleton) {
              var H = k++;
              O = h || (h = c(f)), V = W.bind(null, O, H, !1), j = W.bind(null, O, H, !0);
            } else l.sourceMap && typeof URL == "function" && typeof URL.createObjectURL == "function" && typeof URL.revokeObjectURL == "function" && typeof Blob == "function" && typeof btoa == "function" ? (O = w(f), V = F.bind(null, O, f), j = function() {
              s(O), O.href && URL.revokeObjectURL(O.href);
            }) : (O = c(f), V = $.bind(null, O), j = function() {
              s(O);
            });
            return V(l), function(K) {
              if (K) {
                if (K.css === l.css && K.media === l.media && K.sourceMap === l.sourceMap)
                  return;
                V(l = K);
              } else
                j();
            };
          }
          var B = /* @__PURE__ */ function() {
            var l = [];
            return function(f, O) {
              return l[f] = O, l.filter(Boolean).join(`
`);
            };
          }();
          function W(l, f, O, V) {
            var j = O ? "" : V.css;
            if (l.styleSheet)
              l.styleSheet.cssText = B(f, j);
            else {
              var D = document.createTextNode(j), H = l.childNodes;
              H[f] && l.removeChild(H[f]), H.length ? l.insertBefore(D, H[f]) : l.appendChild(D);
            }
          }
          function $(l, f) {
            var O = f.css, V = f.media;
            if (V && l.setAttribute("media", V), l.styleSheet)
              l.styleSheet.cssText = O;
            else {
              for (; l.firstChild; )
                l.removeChild(l.firstChild);
              l.appendChild(document.createTextNode(O));
            }
          }
          function F(l, f, O) {
            var V = O.css, j = O.sourceMap, D = f.convertToAbsoluteUrls === void 0 && j;
            (f.convertToAbsoluteUrls || D) && (V = _(V)), j && (V += `
/*# sourceMappingURL=data:application/json;base64,` + btoa(unescape(encodeURIComponent(JSON.stringify(j)))) + " */");
            var H = new Blob([V], { type: "text/css" }), ee = l.href;
            l.href = URL.createObjectURL(H), ee && URL.revokeObjectURL(ee);
          }
        },
        /* 10 */
        /***/
        function(M, T) {
          M.exports = function(b) {
            var m = [];
            return m.toString = function() {
              return this.map(function(d) {
                var h = p(d, b);
                return d[2] ? "@media " + d[2] + "{" + h + "}" : h;
              }).join("");
            }, m.i = function(I, d) {
              typeof I == "string" && (I = [[null, I, ""]]);
              for (var h = {}, k = 0; k < this.length; k++) {
                var L = this[k][0];
                typeof L == "number" && (h[L] = !0);
              }
              for (k = 0; k < I.length; k++) {
                var _ = I[k];
                (typeof _[0] != "number" || !h[_[0]]) && (d && !_[2] ? _[2] = d : d && (_[2] = "(" + _[2] + ") and (" + d + ")"), m.push(_));
              }
            }, m;
          };
          function p(b, m) {
            var I = b[1] || "", d = b[3];
            if (!d)
              return I;
            if (m && typeof btoa == "function") {
              var h = v(d), k = d.sources.map(function(L) {
                return "/*# sourceURL=" + d.sourceRoot + L + " */";
              });
              return [I].concat(k).concat([h]).join(`
`);
            }
            return [I].join(`
`);
          }
          function v(b) {
            var m = btoa(unescape(encodeURIComponent(JSON.stringify(b)))), I = "sourceMappingURL=data:application/json;charset=utf-8;base64," + m;
            return "/*# " + I + " */";
          }
        },
        /* 11 */
        /***/
        function(M, T, p) {
          T = M.exports = p(10)(!1), T.push([M.i, '.vidyard-player-container .play-button{position:absolute;width:16%;height:auto;border-radius:50%;border:none;cursor:pointer;opacity:.65;filter:alpha(opacity = 65);transition:opacity .2s linear;overflow:hidden;font-size:0;padding:0;min-width:20px;top:50%;left:50%;transform:translate(-50%,-50%);-webkit-appearance:initial!important;-moz-appearance:initial!important;appearance:initial!important}.vidyard-player-container .play-button .play-button-size{padding-top:100%;width:100%}.vidyard-player-container .play-button .arrow-size{position:absolute;top:50%;left:50%;width:35%;height:auto;margin:-25% 0 0 -12%;overflow:hidden}.vidyard-player-container .play-button .arrow-size-ratio{padding-top:150%;width:100%}.vidyard-player-container .play-button .arrow{position:absolute;top:50%;left:auto;right:0;bottom:auto;width:0;height:0;margin:-200px 0 -200px -300px;border:200px solid transparent;border-left:300px solid #fff;border-right:none}.vidyard-lightbox-thumbnail:hover .play-button{opacity:1;filter:alpha(opacity = 100);zoom:1}.vidyard-player-container{position:relative;height:100%;text-align:center}.vidyard-player-container img{height:100%}.vidyard-player-container .play-button{display:none}.vidyard-close-container{position:fixed;right:20px;top:20px;height:34px;width:34px;cursor:pointer;z-index:1000}.vidyard-close-container:focus{outline:1px dotted grey}.vidyard-close-x{position:absolute;height:100%;width:100%;color:#fff;font-size:2em;text-align:center;line-height:34px}.vidyard-close-x:hover{color:#ddd}.vidyard-close-x:hover:after,.vidyard-close-x:hover:before{background:#ddd}.vidyard-close-x:after,.vidyard-close-x:before{content:"";position:absolute;background:#fff;display:block;left:50%;top:50%;height:65%;width:2px;transition:all .2s;-ms-high-contrast-adjust:none}.vidyard-close-x:before{transform:translate(-50%,-50%) rotate(45deg);-ms-transform:translate(-50%,-50%) rotate(45deg)}.vidyard-close-x:after{transform:translate(-50%,-50%) rotate(-45deg);-ms-transform:translate(-50%,-50%) rotate(-45deg)}.vidyard-close-x.simple-close:after,.vidyard-close-x.simple-close:before{display:none}.vidyard-lightbox-thumbnail{width:100%;height:100%;margin:auto}.vidyard-lightbox-image{height:100%;left:0;position:absolute;top:0;width:100%}.vidyard-lightbox-centering{cursor:pointer;height:0;max-width:100%;overflow:hidden;padding-bottom:56.25%;position:relative}.vidyard-lightbox-content-backer{-webkit-transform:opacity 1s,filter 1s;-ms-transform:opacity 1s,filter 1s;transition:opacity 1s,filter 1s;background-color:#000;height:100%;width:100%;position:absolute}#vidyard-overlay-wrapper,.vidyard-lightbox-content-backer{filter:alpha(opacity = 0);opacity:0;top:0;right:0;bottom:0;left:0}#vidyard-overlay-wrapper{position:relative;box-sizing:border-box;display:none;transition:opacity .5s,filter .5s}#vidyard-overlay{top:0;right:0;bottom:0;left:0;opacity:.9;filter:alpha(opacity = 90);width:100%;height:100%;background-color:#000;z-index:800}#vidyard-content-fixed,#vidyard-overlay{position:fixed;box-sizing:border-box;display:none}#vidyard-content-fixed{opacity:1;z-index:900;text-align:center;top:5%;right:5%;bottom:5%;left:5%;width:90%}#vidyard-popbox{display:inline-block;position:absolute;left:50%;top:50%;-webit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}#vidyard-popbox-constraint{opacity:0;filter:alpha(opacity = 0);display:block;visibility:hidden}#vidyard-popbox-constraint.landscape{height:90vh}#vidyard-popbox-constraint.portrait{width:90vw}.vidyard-player-container div[class^=vidyard-iframe-]{z-index:1}.vidyard-player-container div[class^=vidyard-div-]{background-repeat:no-repeat;background-position:0 50%;background-size:100%}img.vidyard-player-embed{width:100%}img.vidyard-player-embed.inserted{position:absolute;top:0;left:0;z-index:0;max-width:100%!important}.vidyard-player-container.playlist-open{padding-right:319px;width:auto!important}.vidyard-player-container.playlist-open div[class^=vidyard-div-]{width:calc(100% + 319px);max-width:calc(100% + 319px)!important;background-size:calc(100% - 319px);background-color:#f5f9ff}.vidyard-player-container.playlist-open div[class^=vidyard-div-] img.vidyard-player-embed{width:calc(100% - 319px)!important}#backlink-icon{height:15px;width:15px;margin-right:6px;transition:.3s}#backlink{align-items:center;border-radius:4px;border:3px solid #ebeeff;display:inline-block;float:left;line-height:18px;margin:8px 0 0;outline:none;padding:1px 8px 1px 5px;position:relative;*zoom:1;font-family:Arial,Helvetica Neue,Helvetica,sans-serif;font-style:normal;font-weight:400;font-size:12px;text-decoration:none}#backlink:after,#backlink:before{content:" ";display:table}#backlink:after{clear:both}#backlink:link,#backlink:visited{background:#ebeeff;border-color:#ebeeff;color:#414dd4}#backlink:hover{background:#bfc2ff;color:#1b1a82;cursor:pointer}#backlink:focus,#backlink:hover{border-color:#bfc2ff}#backlink:active{background:#8f97ff;border-color:#8f97ff;color:#0c084d}#backlink-icon{float:left;height:18px;margin-right:5px;position:relative;width:18px}#backlink-text{float:left}', ""]);
        },
        /* 12 */
        /***/
        function(M, T, p) {
          var v = p(11);
          typeof v == "string" && (v = [[M.i, v, ""]]);
          var b, m = { hmr: !0 };
          m.transform = b, m.insertInto = void 0, p(9)(v, m), v.locals && (M.exports = v.locals);
        },
        /* 13 */
        /***/
        function(M, T, p) {
          var v = function(A) {
            return A.nodeType === 1 && A.tagName.toLowerCase() !== "body" && A.tagName.toLowerCase() !== "html";
          }, b = function(A) {
            return A.nodeType === 1 && A.tagName.toLowerCase() !== "script";
          }, m = function(A, y) {
            return A.concat(y);
          };
          function I(x) {
            var A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], y = x.previousSibling;
            return y ? (A.push(y), I(y, A)) : A;
          }
          function d(x) {
            var A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], y = x.nextSibling;
            return y ? (A.push(y), d(y, A)) : A;
          }
          function h(x) {
            var A = I(x).concat(d(x));
            return A.filter(b);
          }
          function k(x) {
            var A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], y = x.parentNode;
            return y ? (A.push(y), k(y, A)) : A;
          }
          function L(x) {
            return k(x).filter(v);
          }
          function _(x) {
            return L(x).map(function(A) {
              return h(A);
            }).reduce(m, []);
          }
          M.exports = {
            getSiblings: h,
            getAncestors: L,
            getSiblingsOfAncestors: _
          };
        },
        /* 14 */
        /***/
        function(M, T, p) {
          (function(v) {
            var b = v.CustomEvent;
            function m() {
              try {
                var I = new b("cat", { detail: { foo: "bar" } });
                return I.type === "cat" && I.detail.foo === "bar";
              } catch {
              }
              return !1;
            }
            M.exports = m() ? b : (
              // IE >= 9
              typeof document < "u" && typeof document.createEvent == "function" ? function(d, h) {
                var k = document.createEvent("CustomEvent");
                return h ? k.initCustomEvent(d, h.bubbles, h.cancelable, h.detail) : k.initCustomEvent(d, !1, !1, void 0), k;
              } : (
                // IE <= 8
                function(d, h) {
                  var k = document.createEventObject();
                  return k.type = d, h ? (k.bubbles = !!h.bubbles, k.cancelable = !!h.cancelable, k.detail = h.detail) : (k.bubbles = !1, k.cancelable = !1, k.detail = void 0), k;
                }
              )
            );
          }).call(this, p(0));
        },
        ,
        /* 16 */
        /***/
        function(M, T) {
          var p = M.exports = {}, v, b;
          function m() {
            throw new Error("setTimeout has not been defined");
          }
          function I() {
            throw new Error("clearTimeout has not been defined");
          }
          (function() {
            try {
              typeof setTimeout == "function" ? v = setTimeout : v = m;
            } catch {
              v = m;
            }
            try {
              typeof clearTimeout == "function" ? b = clearTimeout : b = I;
            } catch {
              b = I;
            }
          })();
          function d(w) {
            if (v === setTimeout)
              return setTimeout(w, 0);
            if ((v === m || !v) && setTimeout)
              return v = setTimeout, setTimeout(w, 0);
            try {
              return v(w, 0);
            } catch {
              try {
                return v.call(null, w, 0);
              } catch {
                return v.call(this, w, 0);
              }
            }
          }
          function h(w) {
            if (b === clearTimeout)
              return clearTimeout(w);
            if ((b === I || !b) && clearTimeout)
              return b = clearTimeout, clearTimeout(w);
            try {
              return b(w);
            } catch {
              try {
                return b.call(null, w);
              } catch {
                return b.call(this, w);
              }
            }
          }
          var k = [], L = !1, _, x = -1;
          function A() {
            !L || !_ || (L = !1, _.length ? k = _.concat(k) : x = -1, k.length && y());
          }
          function y() {
            if (!L) {
              var w = d(A);
              L = !0;
              for (var u = k.length; u; ) {
                for (_ = k, k = []; ++x < u; )
                  _ && _[x].run();
                x = -1, u = k.length;
              }
              _ = null, L = !1, h(w);
            }
          }
          p.nextTick = function(w) {
            var u = new Array(arguments.length - 1);
            if (arguments.length > 1)
              for (var C = 1; C < arguments.length; C++)
                u[C - 1] = arguments[C];
            k.push(new s(w, u)), k.length === 1 && !L && d(y);
          };
          function s(w, u) {
            this.fun = w, this.array = u;
          }
          s.prototype.run = function() {
            this.fun.apply(null, this.array);
          }, p.title = "browser", p.browser = !0, p.env = {}, p.argv = [], p.version = "", p.versions = {};
          function c() {
          }
          p.on = c, p.addListener = c, p.once = c, p.off = c, p.removeListener = c, p.removeAllListeners = c, p.emit = c, p.prependListener = c, p.prependOnceListener = c, p.listeners = function(w) {
            return [];
          }, p.binding = function(w) {
            throw new Error("process.binding is not supported");
          }, p.cwd = function() {
            return "/";
          }, p.chdir = function(w) {
            throw new Error("process.chdir is not supported");
          }, p.umask = function() {
            return 0;
          };
        },
        /* 17 */
        /***/
        function(M, T, p) {
          (function(v, b) {
            (function(m, I) {
              if (m.setImmediate)
                return;
              var d = 1, h = {}, k = !1, L = m.document, _;
              function x(F) {
                typeof F != "function" && (F = new Function("" + F));
                for (var l = new Array(arguments.length - 1), f = 0; f < l.length; f++)
                  l[f] = arguments[f + 1];
                var O = { callback: F, args: l };
                return h[d] = O, _(d), d++;
              }
              function A(F) {
                delete h[F];
              }
              function y(F) {
                var l = F.callback, f = F.args;
                switch (f.length) {
                  case 0:
                    l();
                    break;
                  case 1:
                    l(f[0]);
                    break;
                  case 2:
                    l(f[0], f[1]);
                    break;
                  case 3:
                    l(f[0], f[1], f[2]);
                    break;
                  default:
                    l.apply(I, f);
                    break;
                }
              }
              function s(F) {
                if (k)
                  setTimeout(s, 0, F);
                else {
                  var l = h[F];
                  if (l) {
                    k = !0;
                    try {
                      y(l);
                    } finally {
                      A(F), k = !1;
                    }
                  }
                }
              }
              function c() {
                _ = function(F) {
                  b.nextTick(function() {
                    s(F);
                  });
                };
              }
              function w() {
                if (m.postMessage && !m.importScripts) {
                  var F = !0, l = m.onmessage;
                  return m.onmessage = function() {
                    F = !1;
                  }, m.postMessage("", "*"), m.onmessage = l, F;
                }
              }
              function u() {
                var F = "setImmediate$" + Math.random() + "$", l = function(f) {
                  f.source === m && typeof f.data == "string" && f.data.indexOf(F) === 0 && s(+f.data.slice(F.length));
                };
                m.addEventListener ? m.addEventListener("message", l, !1) : m.attachEvent("onmessage", l), _ = function(f) {
                  m.postMessage(F + f, "*");
                };
              }
              function C() {
                var F = new MessageChannel();
                F.port1.onmessage = function(l) {
                  var f = l.data;
                  s(f);
                }, _ = function(l) {
                  F.port2.postMessage(l);
                };
              }
              function B() {
                var F = L.documentElement;
                _ = function(l) {
                  var f = L.createElement("script");
                  f.onreadystatechange = function() {
                    s(l), f.onreadystatechange = null, F.removeChild(f), f = null;
                  }, F.appendChild(f);
                };
              }
              function W() {
                _ = function(F) {
                  setTimeout(s, 0, F);
                };
              }
              var $ = Object.getPrototypeOf && Object.getPrototypeOf(m);
              $ = $ && $.setTimeout ? $ : m, {}.toString.call(m.process) === "[object process]" ? c() : w() ? u() : m.MessageChannel ? C() : L && "onreadystatechange" in L.createElement("script") ? B() : W(), $.setImmediate = x, $.clearImmediate = A;
            })(typeof self > "u" ? typeof v > "u" ? this : v : self);
          }).call(this, p(0), p(16));
        },
        /* 18 */
        /***/
        function(M, T, p) {
          (function(v) {
            var b = typeof v < "u" && v || typeof self < "u" && self || window, m = Function.prototype.apply;
            T.setTimeout = function() {
              return new I(m.call(setTimeout, b, arguments), clearTimeout);
            }, T.setInterval = function() {
              return new I(m.call(setInterval, b, arguments), clearInterval);
            }, T.clearTimeout = T.clearInterval = function(d) {
              d && d.close();
            };
            function I(d, h) {
              this._id = d, this._clearFn = h;
            }
            I.prototype.unref = I.prototype.ref = function() {
            }, I.prototype.close = function() {
              this._clearFn.call(b, this._id);
            }, T.enroll = function(d, h) {
              clearTimeout(d._idleTimeoutId), d._idleTimeout = h;
            }, T.unenroll = function(d) {
              clearTimeout(d._idleTimeoutId), d._idleTimeout = -1;
            }, T._unrefActive = T.active = function(d) {
              clearTimeout(d._idleTimeoutId);
              var h = d._idleTimeout;
              h >= 0 && (d._idleTimeoutId = setTimeout(function() {
                d._onTimeout && d._onTimeout();
              }, h));
            }, p(17), T.setImmediate = typeof self < "u" && self.setImmediate || typeof v < "u" && v.setImmediate || this && this.setImmediate, T.clearImmediate = typeof self < "u" && self.clearImmediate || typeof v < "u" && v.clearImmediate || this && this.clearImmediate;
          }).call(this, p(0));
        }
        /******/
      ])
    );
  });
})(ot);
var ut = ot.exports;
const Mn = /* @__PURE__ */ Un(ut), Bn = /* @__PURE__ */ Vn({
  __proto__: null,
  default: Mn
}, [ut]);
export {
  Bn as v
};
